(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4597],{

/***/ 53559:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/governments/[governmentSlug]/[[...content]]",
      function () {
        return __webpack_require__(29209);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 58741:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AwardsBox; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(93712);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(94614);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(56262);
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.9.0_g2nyo56cszy7jhpiictt6fwifm/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(82789);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+core@0.21.2_iyni55cf3gelv6eahxhjaprhn4/node_modules/@govlaunch/core/index.js + 20 modules
var core = __webpack_require__(98973);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+palette@0.4.0/node_modules/@govlaunch/palette/index.js
var palette = __webpack_require__(95576);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+popover@0.10.2_qlbrybfyutdb3nzvgq5n4v5xcq/node_modules/@govlaunch/popover/index.js + 59 modules
var popover = __webpack_require__(70271);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/fp/difference.js
var difference = __webpack_require__(48471);
var difference_default = /*#__PURE__*/__webpack_require__.n(difference);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-use@17.4.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-use/esm/useToggle.js
var useToggle = __webpack_require__(35150);
// EXTERNAL MODULE: ./components/profile/EmptyBlocks.tsx
var EmptyBlocks = __webpack_require__(32796);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(18316);
// EXTERNAL MODULE: ./components/Tooltip.tsx
var Tooltip = __webpack_require__(79313);
;// CONCATENATED MODULE: ./components/awards/Award.tsx







function Award(_param) {
    var award = _param.award, props = (0,_object_without_properties/* default */.Z)(_param, [
        "award"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tooltip/* default */.Z, {
        backgroundColor: palette/* mediumBlue */.t,
        boxStyle: {
            borderRadius: 13.5,
            boxShadow: "0 2px 5px 0px rgba(0, 0, 0, 0.5)"
        },
        render: function() {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    padding: 8,
                    color: palette/* text */.fL,
                    fontSize: 14
                },
                children: award.name
            });
        },
        children: function(param) {
            var innerRef = param.innerRef, bind = param.bind;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                ref: innerRef,
                css: {
                    padding: "5px 10px",
                    marginTop: 8,
                    marginRight: 8,
                    backgroundColor: palette/* mediumBlue */.t,
                    borderRadius: 13.5,
                    fontSize: 14,
                    color: palette/* text */.fL,
                    lineClamp: 1,
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    maxWidth: "45%"
                }
            }, bind, props), {
                children: award.name
            }));
        }
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/react-final-form@6.5.9_s44h3cxpdxv6cks4bnqewerqda/node_modules/react-final-form/dist/react-final-form.es.js
var react_final_form_es = __webpack_require__(56225);
// EXTERNAL MODULE: ./components/tag/TagsSelect.tsx
var TagsSelect = __webpack_require__(90731);
// EXTERNAL MODULE: ./types/types.ts
var types = __webpack_require__(43845);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(69057);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(90489);
;// CONCATENATED MODULE: ./components/awards/AwardsForm.tsx











function AwardsForm(_param) {
    var onCancel = _param.onCancel, props = (0,_object_without_properties/* default */.Z)(_param, [
        "onCancel"
    ]);
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Form */.l0, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: function(param) {
            var handleSubmit = param.handleSubmit, submitting = param.submitting;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("form", {
                onSubmit: handleSubmit,
                css: {
                    margin: 0,
                    padding: 0
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
                        name: "awards",
                        children: function(param) {
                            var input = param.input;
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagsSelect/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, input), {
                                type: types/* ITagType.Award */.mG.Award,
                                placeholder: intl.formatMessage({
                                    defaultMessage: "Type to select awards...",
                                    id: "OqzbA+"
                                })
                            }));
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: {
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "center",
                            marginTop: 16
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                                type: "submit",
                                disabled: submitting,
                                theme: "link",
                                textColor: palette/* primary */.T$,
                                css: {
                                    height: "auto",
                                    padding: 0,
                                    textTransform: "uppercase",
                                    ":disabled": {
                                        opacity: 0.4
                                    }
                                },
                                children: submitting ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Saving",
                                    id: "QLkzoS"
                                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Save",
                                    id: "jvo0vs"
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                                type: "button",
                                onClick: onCancel,
                                theme: "link",
                                textColor: palette/* sealBlue */.N9,
                                css: {
                                    height: "auto",
                                    padding: 0,
                                    marginLeft: 8,
                                    textTransform: "uppercase"
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Cancel",
                                    id: "47FYwb"
                                })
                            })
                        ]
                    })
                ]
            });
        }
    }));
};

;// CONCATENATED MODULE: ./components/awards/AwardsBox.tsx














function AwardsBox(_param) {
    var awards = _param.awards, onSubmit = _param.onSubmit, onAddLink = _param.onAddLink, _readOnly = _param.readOnly, readOnly = _readOnly === void 0 ? false : _readOnly, props = (0,_object_without_properties/* default */.Z)(_param, [
        "awards",
        "onSubmit",
        "onAddLink",
        "readOnly"
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)((0,useToggle/* default */.Z)(false), 2), isEditing = ref[0], toggle = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useToggle/* default */.Z)(false), 2), isTooltipOpen = ref1[0], toggleTooltip = ref1[1];
    if (readOnly && awards.length === 0) {
        return null;
    }
    if (awards.length === 0 && !isEditing) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyBlocks/* NoAwards */.mp, {
            onAddAwards: toggle
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(popover/* default */.Z, {
        isOpen: isTooltipOpen,
        onClickOutside: toggleTooltip,
        placement: "right",
        render: function() {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    width: 275,
                    padding: 16
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: {
                            paddingBottom: 8,
                            borderBottom: "1px solid ".concat(palette/* lightestGray */.v2),
                            color: palette/* mediumGray */.rF
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Do you want to add a link about the award?",
                            id: "epDw9F"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-end",
                            marginTop: 8
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                                size: "xsmall",
                                color: palette/* primary */.T$,
                                type: "button",
                                onClick: function() {
                                    onAddLink();
                                    toggleTooltip();
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Yes",
                                    id: "a5msuh"
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                                size: "xsmall",
                                theme: "secondary",
                                onClick: toggleTooltip,
                                color: palette/* primary */.T$,
                                css: {
                                    marginLeft: 8
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "No",
                                    id: "oUWADl"
                                })
                            })
                        ]
                    })
                ]
            });
        },
        children: function(param) {
            var innerRef = param.innerRef;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                ref: innerRef,
                css: {
                    background: "#fff",
                    borderRadius: 4,
                    border: "1px solid ".concat(palette/* lightestGray */.v2)
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: {
                            padding: 16,
                            display: "flex",
                            borderBottom: "1px solid ".concat(palette/* lightestGray */.v2)
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                css: {
                                    fontSize: 12,
                                    fontWeight: 500,
                                    color: palette/* sealBlue */.N9,
                                    textTransform: "uppercase"
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "\uD83C\uDFC5 Awards",
                                    id: "RT1ZpG"
                                })
                            }),
                            awards.length > 0 && !isEditing && !readOnly && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                role: "button",
                                css: {
                                    marginLeft: "auto",
                                    fontWeight: 500,
                                    textTransform: "uppercase",
                                    color: palette/* primary */.T$,
                                    cursor: "pointer",
                                    fontSize: 14
                                },
                                onClick: toggle,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Edit",
                                    id: "wEQDC6"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: {
                            padding: 16
                        },
                        children: [
                            !isEditing && awards.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                css: {
                                    width: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    flexWrap: "wrap",
                                    marginTop: -8,
                                    // something is strange with the way this component is built and if a maxWidth is not set
                                    // and the Award itself becomes too wide it messes the whole page layout
                                    maxWidth: 320
                                },
                                children: awards.map(function(award) {
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Award, {
                                        award: award
                                    }, award._id);
                                })
                            }),
                            isEditing && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AwardsForm, (0,_object_spread/* default */.Z)({
                                onCancel: toggle,
                                initialValues: {
                                    awards: awards
                                },
                                onSubmit: function(values, form) {
                                    var hasDifferentAwards = difference_default()(values.awards.map(function(param) {
                                        var _id = param._id, objectID = param.objectID;
                                        return _id || objectID;
                                    }), awards.map(function(param) {
                                        var _id = param._id;
                                        return _id;
                                    })).length > 0;
                                    return Promise.resolve(onSubmit(values, form)).then(toggle).then(function() {
                                        if (values.awards.length > 0 && hasDifferentAwards) {
                                            toggleTooltip();
                                        }
                                    });
                                }
                            }, props))
                        ]
                    })
                ]
            });
        }
    });
};


/***/ }),

/***/ 15545:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ NoResultsFound; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var _govlaunch_palette__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95576);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90489);




function NoResultsFound() {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("p", {
        css: {
            fontSize: 14,
            color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_2__/* .mediumGray */ .rF
        },
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            defaultMessage: "Sorry, no results found.",
            id: "Lpps9D"
        })
    });
};


/***/ }),

/***/ 93430:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ apostrophe; }
/* harmony export */ });
function apostrophe(name) {
    if (!name) {
        return "";
    } else if (/s$/i.test(name)) {
        return "".concat(name, "'");
    } else {
        return "".concat(name, "'s");
    }
};


/***/ }),

/***/ 79438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getCityType; }
/* harmony export */ });
function getCityType(governmentType) {
    return governmentType.replace(/(\b[a-z](?!\s))/g, function(letter) {
        return letter.toUpperCase();
    });
// if (governmentType === "county") {
//   return "County";
// } else if (governmentType === "township") {
//   return "Township";
// } else {
//   return "City";
// }
};


/***/ }),

/***/ 29209:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _content_; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(49980);
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.9.0_g2nyo56cszy7jhpiictt6fwifm/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(82789);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.9_mnlteiidv5se4zpyvopwg4rohq/node_modules/@apollo/client/react/components/Query.js
var Query = __webpack_require__(38085);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.9_mnlteiidv5se4zpyvopwg4rohq/node_modules/@apollo/client/react/components/Mutation.js
var Mutation = __webpack_require__(82280);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+core@0.21.2_iyni55cf3gelv6eahxhjaprhn4/node_modules/@govlaunch/core/index.js + 20 modules
var core = __webpack_require__(98973);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+palette@0.4.0/node_modules/@govlaunch/palette/index.js
var palette = __webpack_require__(95576);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/fp.js
var fp = __webpack_require__(56365);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/router.js
var next_router = __webpack_require__(22051);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(69057);
// EXTERNAL MODULE: ./components/auth/Auth.tsx + 1 modules
var Auth = __webpack_require__(27068);
// EXTERNAL MODULE: ./components/cover/Cover.tsx + 3 modules
var Cover = __webpack_require__(42607);
// EXTERNAL MODULE: ./components/feed/Feed.tsx
var Feed = __webpack_require__(45896);
// EXTERNAL MODULE: ./components/feed/WriteContentBox.tsx + 6 modules
var WriteContentBox = __webpack_require__(54436);
// EXTERNAL MODULE: ./components/spacings.tsx
var spacings = __webpack_require__(52126);
// EXTERNAL MODULE: ./components/icons/BadgeCheckIcon.tsx
var BadgeCheckIcon = __webpack_require__(23742);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(93712);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(18316);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+profile-picture@1.4.1/node_modules/@govlaunch/profile-picture/index.js + 1 modules
var profile_picture = __webpack_require__(77876);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/link.js
var next_link = __webpack_require__(54892);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(90489);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-powerplug@1.0.0_react@17.0.2/node_modules/react-powerplug/dist/react-powerplug.esm.js
var react_powerplug_esm = __webpack_require__(41491);
// EXTERNAL MODULE: ./lib/apollo/RefetchQueriesFixLink.ts
var RefetchQueriesFixLink = __webpack_require__(69086);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(17440);
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@16.5.0/node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(18125);
// EXTERNAL MODULE: ./lib/queries/fragments/GroupProjectFields.ts
var GroupProjectFields = __webpack_require__(94070);
// EXTERNAL MODULE: ./lib/queries/fragments/GovernmentProjectFields.ts
var GovernmentProjectFields = __webpack_require__(42046);
// EXTERNAL MODULE: ./lib/queries/fragments/VendorProjectFields.ts
var VendorProjectFields = __webpack_require__(4511);
;// CONCATENATED MODULE: ./lib/mutations/DeclineProjectVerification.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation DeclineProjectVerification($projectId: ObjectId!, $governmentId: ObjectId!) {\n    declineProjectVerification(projectId: $projectId, governmentId: $governmentId) {\n      _id\n      ... on ProjectGovernmentVerificationRequest {\n        project {\n          _id\n          ...GroupProjectFields\n          ...GovernmentProjectFields\n          ...VendorProjectFields\n        }\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




/* harmony default export */ var DeclineProjectVerification = ((0,lib/* gql */.Ps)(_templateObject(), GroupProjectFields/* default */.Z, GovernmentProjectFields/* default */.Z, VendorProjectFields/* default */.Z));

// EXTERNAL MODULE: ./lib/mutations/DismissActionCenter.ts
var DismissActionCenter = __webpack_require__(32785);
;// CONCATENATED MODULE: ./lib/mutations/VerifyProject.ts

function VerifyProject_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation VerifyProject($projectId: ObjectId!, $governmentId: ObjectId!) {\n    verifyProject(projectId: $projectId, governmentId: $governmentId) {\n      _id\n      ... on ProjectGovernmentVerificationRequest {\n        project {\n          _id\n          ...GroupProjectFields\n          ...GovernmentProjectFields\n          ...VendorProjectFields\n        }\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    VerifyProject_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




/* harmony default export */ var VerifyProject = ((0,lib/* gql */.Ps)(VerifyProject_templateObject(), GroupProjectFields/* default */.Z, GovernmentProjectFields/* default */.Z, VendorProjectFields/* default */.Z));

// EXTERNAL MODULE: ./lib/utils/strongify.tsx
var strongify = __webpack_require__(11135);
// EXTERNAL MODULE: ./src/shared/components/IntlRelativeTime.tsx
var IntlRelativeTime = __webpack_require__(89989);
// EXTERNAL MODULE: ./src/utils/nextLinkHref.ts
var nextLinkHref = __webpack_require__(88196);
// EXTERNAL MODULE: ./components/icons/CheckIcon.tsx
var CheckIcon = __webpack_require__(77820);
// EXTERNAL MODULE: ./components/icons/CloseIcon.tsx
var CloseIcon = __webpack_require__(80937);
;// CONCATENATED MODULE: ./components/government/actions/ProjectGovernmentVerificationRequest.tsx























function ProjectGovernmentVerificationRequest(param) {
    var action = param.action;
    var ref = (0,react.useState)(false), verifiedProjectState = ref[0], setVerifiedProjectState = ref[1];
    var ref1 = (0,react.useState)(false), declinedProjectState = ref1[0], setDeclinedProjectState = ref1[1];
    var viewer = (0,Auth/* useSelfie */.yD)();
    var router = (0,next_router.useRouter)();
    var intl = (0,useIntl/* default */.Z)();
    // We use both hook and apollo data to check if project is verified/declined
    var verifiedProject = verifiedProjectState || action.status.toUpperCase() === "VERIFIED";
    var declinedProject = declinedProjectState || action.status.toUpperCase() === "DECLINED";
    if (!viewer || viewer.__typename !== "GovernmentUser") {
        return null;
    }
    var project = action.project;
    if (project.__typename === "GovernmentProject") {
        return null;
    }
    var projectType = project.__typename === "GroupProject" ? intl.formatMessage({
        defaultMessage: "group",
        id: "JsQ2Bn"
    }) : intl.formatMessage({
        defaultMessage: "vendor",
        id: "PjezAc"
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
        mutation: DismissActionCenter/* default */.Z,
        children: function(dismissActionCenter) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    display: "flex",
                    alignItems: "center",
                    padding: 12,
                    backgroundColor: palette/* white */.ix,
                    ":hover": {
                        backgroundColor: palette/* washGray */.aF
                    }
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(profile_picture/* default */.Z, {
                        size: 46,
                        image: project.__typename === "GroupProject" ? project.group.logo : project.vendor.logo,
                        name: project.__typename === "GroupProject" ? project.group.name : project.vendor.name
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                        ml: 12,
                        mr: "auto",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
                            css: {
                                fontSize: 14,
                                color: palette/* mediumGray */.rF,
                                margin: 0,
                                lineHeight: "18px"
                            },
                            children: [
                                project.author && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                    passHref: true,
                                    href: "/[userSlug]/[[...tab]]",
                                    as: "/@".concat(project.author.slug),
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                        css: {
                                            color: palette/* primary */.T$,
                                            fontWeight: 600,
                                            ":hover": {
                                                textDecoration: "underline !important"
                                            }
                                        },
                                        children: project.author.fullName
                                    })
                                }),
                                " ",
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "from {projectType} <strong>{projectName}</strong> has requested to associate your government to the project",
                                    id: "z51ctt",
                                    values: {
                                        projectType: projectType,
                                        projectName: project.__typename === "GroupProject" ? project.group.name : project.vendor.name,
                                        strong: function(chunk) {
                                            return (0,strongify/* default */.Z)(chunk);
                                        }
                                    }
                                }),
                                " ",
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                    href: (0,nextLinkHref/* appendNextLinkHrefParams */.o)(router, {
                                        projectSlug: project.slug
                                    }),
                                    as: "/projects/".concat(project.slug),
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                        css: {
                                            fontWeight: 600,
                                            color: palette/* primary */.T$,
                                            ":hover": {
                                                textDecoration: "underline !important"
                                            }
                                        },
                                        children: project.title
                                    })
                                }),
                                " ",
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                    css: {
                                        color: palette/* sealBlue */.N9,
                                        fontSize: 12,
                                        whiteSpace: "nowrap"
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IntlRelativeTime/* default */.Z, {
                                        value: action.createdAt
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: {
                            display: "flex",
                            width: 170,
                            minWidth: 170,
                            justifyContent: "flex-end"
                        },
                        children: [
                            verifiedProject && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                ml: "auto",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                    css: {
                                        display: "flex",
                                        alignItems: "center",
                                        color: palette/* greenBlue */.TG
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CheckIcon/* default */.Z, {}),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                            ml: 6,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                css: {
                                                    fontSize: 14,
                                                    fontWeight: 500
                                                },
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                    defaultMessage: "Verified",
                                                    id: "Z8971h"
                                                })
                                            })
                                        })
                                    ]
                                })
                            }),
                            declinedProject && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                ml: "auto",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                    css: {
                                        display: "flex",
                                        alignItems: "center",
                                        color: palette/* red */.Q6
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CloseIcon/* default */.Z, {
                                            fill: palette/* red */.Q6,
                                            variation: "thick",
                                            width: 15,
                                            height: 15
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                            ml: 8,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                css: {
                                                    fontSize: 14,
                                                    fontWeight: 500
                                                },
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                    defaultMessage: "Declined",
                                                    id: "uRYIb9"
                                                })
                                            })
                                        })
                                    ]
                                })
                            }),
                            !verifiedProject && !declinedProject && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                css: {
                                    display: "grid",
                                    gridAutoFlow: "column",
                                    alignItems: "center",
                                    gridColumnGap: 12
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
                                        mutation: VerifyProject,
                                        refetchQueries: (0,RefetchQueriesFixLink/* refetchQueries */.h)([
                                            "VerifiedGovernmentProjects"
                                        ]),
                                        children: function(verifyProject) {
                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Hover */.TM, {
                                                children: function(param) {
                                                    var bind = param.bind, hovered = param.hovered;
                                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                        theme: hovered ? "primary" : "secondary",
                                                        size: "xsmall",
                                                        color: palette/* innovatorBlue */.LD,
                                                        style: {
                                                            opacity: 1,
                                                            backgroundColor: hovered ? palette/* innovatorBlue */.LD : palette/* white */.ix,
                                                            width: 100
                                                        }
                                                    }, bind), {
                                                        onClick: function() {
                                                            verifyProject({
                                                                variables: {
                                                                    governmentId: viewer.government._id,
                                                                    projectId: project._id
                                                                }
                                                            });
                                                            dismissActionCenter();
                                                            setVerifiedProjectState(true);
                                                        },
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                            css: {
                                                                whiteSpace: "nowrap"
                                                            },
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                                defaultMessage: "Verify Project",
                                                                id: "DLRCfU"
                                                            })
                                                        })
                                                    }));
                                                }
                                            });
                                        }
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
                                        mutation: DeclineProjectVerification,
                                        children: function(declineProjectVerification) {
                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                css: {
                                                    cursor: "pointer",
                                                    fontSize: 12,
                                                    color: palette/* red */.Q6,
                                                    ":hover": {
                                                        textDecoration: "underline"
                                                    }
                                                },
                                                onClick: function() {
                                                    if (window.confirm("Are you sure you want to decline the verification of ".concat(project.title, "?"))) {
                                                        declineProjectVerification({
                                                            variables: {
                                                                governmentId: viewer.government._id,
                                                                projectId: project._id
                                                            }
                                                        });
                                                        dismissActionCenter();
                                                        setDeclinedProjectState(true);
                                                    }
                                                },
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                    id: "pvtgR2",
                                                    defaultMessage: "Decline"
                                                })
                                            });
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                ]
            });
        }
    });
}
/* harmony default export */ var actions_ProjectGovernmentVerificationRequest = (ProjectGovernmentVerificationRequest);

;// CONCATENATED MODULE: ./lib/queries/GovernmentActionsQuery.ts

function GovernmentActionsQuery_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GovernmentActions($governmentSlug: String!) {\n    government(slug: $governmentSlug) {\n      _id\n      actionsCount\n      actions {\n        ... on GroupRequest {\n          _id\n          group {\n            _id\n            slug\n            name\n            logo\n          }\n          inviter {\n            ... on PendingUser {\n              _id\n              slug\n              fullName\n              avatar\n            }\n            ... on VendorUser {\n              _id\n              slug\n              fullName\n              avatar\n            }\n            ... on GovernmentUser {\n              _id\n              slug\n              fullName\n              avatar\n            }\n          }\n          createdAt\n        }\n\n        ... on ProductStackRequest {\n          _id\n          product {\n            _id\n            slug\n            name\n            logo\n          }\n          vendor {\n            _id\n            slug\n            name\n            logo\n          }\n          inviter {\n            ... on PendingUser {\n              _id\n              slug\n              fullName\n              avatar\n            }\n            ... on VendorUser {\n              _id\n              slug\n              fullName\n              avatar\n            }\n            ... on GovernmentUser {\n              _id\n              slug\n              fullName\n              avatar\n            }\n          }\n          createdAt\n        }\n\n        ... on ProjectGovernmentVerificationRequest {\n          _id\n          status\n          project {\n            ... on GroupProject {\n              _id\n              slug\n              title\n              audience\n              author {\n                ... on PendingUser {\n                  _id\n                  slug\n                  fullName\n                  avatar\n                }\n                ... on VendorUser {\n                  _id\n                  slug\n                  fullName\n                  avatar\n                }\n                ... on GovernmentUser {\n                  _id\n                  slug\n                  fullName\n                  avatar\n                }\n              }\n              group {\n                _id\n                slug\n                name\n                logo\n              }\n            }\n            ... on VendorProject {\n              _id\n              slug\n              title\n              audience\n              author {\n                ... on PendingUser {\n                  _id\n                  slug\n                  fullName\n                  avatar\n                }\n                ... on VendorUser {\n                  _id\n                  slug\n                  fullName\n                  avatar\n                }\n                ... on GovernmentUser {\n                  _id\n                  slug\n                  fullName\n                  avatar\n                }\n              }\n              vendor {\n                _id\n                slug\n                name\n                logo\n              }\n            }\n          }\n\n          createdAt\n        }\n      }\n    }\n  }\n"
    ]);
    GovernmentActionsQuery_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var GovernmentActionsQuery = ((0,lib/* gql */.Ps)(GovernmentActionsQuery_templateObject()));

// EXTERNAL MODULE: ./lib/queries/SelfieQuery.ts
var SelfieQuery = __webpack_require__(88877);
// EXTERNAL MODULE: ./components/actions/GroupRequestAction.tsx + 2 modules
var GroupRequestAction = __webpack_require__(22695);
;// CONCATENATED MODULE: ./lib/mutations/AcceptProductStackRequest.ts

function AcceptProductStackRequest_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation AcceptProductStackRequest($requestId: ObjectId!) {\n    acceptProductStackRequest(requestId: $requestId)\n  }\n"
    ]);
    AcceptProductStackRequest_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var AcceptProductStackRequest = ((0,lib/* gql */.Ps)(AcceptProductStackRequest_templateObject()));

;// CONCATENATED MODULE: ./lib/mutations/DeclineProductStackRequest.ts

function DeclineProductStackRequest_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation DeclineProductStackRequest($requestId: ObjectId!) {\n    declineProductStackRequest(requestId: $requestId)\n  }\n"
    ]);
    DeclineProductStackRequest_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var DeclineProductStackRequest = ((0,lib/* gql */.Ps)(DeclineProductStackRequest_templateObject()));

;// CONCATENATED MODULE: ./components/actions/ProductStackRequestAction.tsx



















function ProductStackRequestAction(param) {
    var action = param.action;
    var intl = (0,useIntl/* default */.Z)();
    var ref = (0,react.useState)(false), acceptedProduct = ref[0], setAcceptedProduct = ref[1];
    var ref1 = (0,react.useState)(false), declinedProduct = ref1[0], setDeclinedProduct = ref1[1];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
        mutation: DismissActionCenter/* default */.Z,
        children: function(dismissActionCenter) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    display: "flex",
                    alignItems: "center",
                    padding: 12,
                    backgroundColor: palette/* white */.ix,
                    ":hover": {
                        backgroundColor: palette/* washGray */.aF
                    }
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(profile_picture/* default */.Z, {
                        size: 46,
                        image: action.product.logo,
                        name: action.product.name
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                        ml: 12,
                        mr: "auto",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
                            css: {
                                fontSize: 14,
                                color: palette/* mediumGray */.rF,
                                margin: 0,
                                lineHeight: "18px"
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                    passHref: true,
                                    href: "/[userSlug]/[[...tab]]",
                                    as: "/@".concat(action.inviter.slug),
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                        css: {
                                            color: palette/* primary */.T$,
                                            fontWeight: 600,
                                            ":hover": {
                                                textDecoration: "underline !important"
                                            }
                                        },
                                        children: action.inviter.fullName
                                    })
                                }),
                                " ",
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "invited your government to add {productName} from vendor {vendorName}",
                                    id: "9pW94p",
                                    values: {
                                        productName: action.product.name,
                                        vendorName: action.vendor.name
                                    }
                                }),
                                " ",
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                    css: {
                                        color: palette/* sealBlue */.N9,
                                        fontSize: 12,
                                        whiteSpace: "nowrap"
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IntlRelativeTime/* default */.Z, {
                                        value: action.createdAt
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: {
                            display: "flex",
                            width: 170,
                            minWidth: 170,
                            justifyContent: "flex-end"
                        },
                        children: [
                            acceptedProduct && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                ml: "auto",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                    css: {
                                        display: "flex",
                                        alignItems: "center",
                                        color: palette/* greenBlue */.TG
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CheckIcon/* default */.Z, {}),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                            ml: 6,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                css: {
                                                    fontSize: 14,
                                                    fontWeight: 500
                                                },
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                    defaultMessage: "Added",
                                                    id: "rIAJlE"
                                                })
                                            })
                                        })
                                    ]
                                })
                            }),
                            declinedProduct && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                ml: "auto",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                    css: {
                                        display: "flex",
                                        alignItems: "center",
                                        color: palette/* red */.Q6
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CloseIcon/* default */.Z, {
                                            fill: palette/* red */.Q6,
                                            variation: "thick",
                                            width: 15,
                                            height: 15
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                            ml: 8,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                css: {
                                                    fontSize: 14,
                                                    fontWeight: 500
                                                },
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                    defaultMessage: "Declined",
                                                    id: "uRYIb9"
                                                })
                                            })
                                        })
                                    ]
                                })
                            }),
                            !acceptedProduct && !declinedProduct && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                css: {
                                    display: "grid",
                                    gridAutoFlow: "column",
                                    alignItems: "center",
                                    gridColumnGap: 12
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
                                        mutation: AcceptProductStackRequest,
                                        refetchQueries: (0,RefetchQueriesFixLink/* refetchQueries */.h)([
                                            "Selfie",
                                            "Government"
                                        ]),
                                        children: function(acceptProductStackRequest) {
                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Hover */.TM, {
                                                children: function(param) {
                                                    var bind = param.bind, hovered = param.hovered;
                                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                        theme: hovered ? "primary" : "secondary",
                                                        size: "xsmall",
                                                        color: palette/* innovatorBlue */.LD,
                                                        style: {
                                                            opacity: 1,
                                                            backgroundColor: hovered ? palette/* innovatorBlue */.LD : palette/* white */.ix,
                                                            width: 100
                                                        }
                                                    }, bind), {
                                                        onClick: function() {
                                                            acceptProductStackRequest({
                                                                variables: {
                                                                    requestId: action._id
                                                                }
                                                            });
                                                            dismissActionCenter();
                                                            setAcceptedProduct(true);
                                                        },
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                            css: {
                                                                whiteSpace: "nowrap"
                                                            },
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                                defaultMessage: "Verify Product",
                                                                id: "Q5gWEo"
                                                            })
                                                        })
                                                    }));
                                                }
                                            });
                                        }
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
                                        mutation: DeclineProductStackRequest,
                                        children: function(declineProductStackRequest) {
                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                css: {
                                                    cursor: "pointer",
                                                    fontSize: 12,
                                                    color: palette/* red */.Q6,
                                                    ":hover": {
                                                        textDecoration: "underline"
                                                    }
                                                },
                                                onClick: function() {
                                                    var message = intl.formatMessage({
                                                        defaultMessage: "Are you sure you want to decline the invite to {productName}?",
                                                        id: "ST82Cr"
                                                    }, {
                                                        productName: action.product.name
                                                    });
                                                    if (window.confirm(message)) {
                                                        declineProductStackRequest({
                                                            variables: {
                                                                requestId: action._id
                                                            }
                                                        });
                                                        dismissActionCenter();
                                                        setDeclinedProduct(true);
                                                    }
                                                },
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                    id: "pvtgR2",
                                                    defaultMessage: "Decline"
                                                })
                                            });
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                ]
            });
        }
    });
}
/* harmony default export */ var actions_ProductStackRequestAction = (ProductStackRequestAction);

// EXTERNAL MODULE: ./src/utils/stringOrFirst.ts
var stringOrFirst = __webpack_require__(39327);
// EXTERNAL MODULE: ./src/components/project/modal/ProjectModal.tsx + 4 modules
var ProjectModal = __webpack_require__(96077);
;// CONCATENATED MODULE: ./components/government/GovernmentActions.tsx















function GovernmentActions(param) {
    var governmentSlug = param.governmentSlug;
    var router = (0,next_router.useRouter)();
    var projectSlug = (0,stringOrFirst/* default */.Z)(router.query.projectSlug);
    // Since fetchPolicy="network-only" doesn't work on the server, we'll only query when rendering in the browser
    if (false) {}
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        "data-intercom-target": "Government Actions",
        css: {
            display: "block"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Query/* Query */.A, {
                query: GovernmentActionsQuery,
                fetchPolicy: "network-only",
                variables: {
                    governmentSlug: governmentSlug
                },
                children: function(param) {
                    var data = param.data, loading = param.loading;
                    if (loading || !data || !data.government) {
                        return null;
                    }
                    var actions = data.government.actions;
                    if (actions.length === 0) {
                        return(// We refetch the selfie in case admin has taken action on behalf of the user
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Query/* Query */.A, {
                            query: SelfieQuery/* default */.Z,
                            fetchPolicy: "network-only",
                            children: function() {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                    css: {
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        borderRadius: 5,
                                        border: "solid 1px ".concat(palette/* lightestGray */.v2),
                                        backgroundColor: palette/* white */.ix,
                                        color: palette/* mediumGray */.rF,
                                        padding: 26
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BadgeCheckIcon/* default */.Z, {}),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                            ml: 14,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                css: {
                                                    fontSize: 18,
                                                    fontWeight: 500
                                                },
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                    defaultMessage: "No actions to take",
                                                    id: "pWGG1V"
                                                })
                                            })
                                        })
                                    ]
                                });
                            }
                        }));
                    }
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: {
                            display: "grid",
                            gridAutoFlow: "row",
                            gridRowGap: 1,
                            border: "solid 1px ".concat(palette/* lightestGray */.v2),
                            backgroundColor: palette/* lightestGray */.v2,
                            borderRadius: 5,
                            overflow: "hidden"
                        },
                        children: actions.map(function(action) {
                            if (action.__typename === "ProjectGovernmentVerificationRequest") {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(actions_ProjectGovernmentVerificationRequest, {
                                    action: action
                                }, action._id);
                            }
                            if (action.__typename === "GovernmentGroupRequest") {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GroupRequestAction/* default */.Z, {
                                    action: action,
                                    entityType: "government"
                                }, action._id);
                            }
                            if (action.__typename === "ProductStackRequest") {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(actions_ProductStackRequestAction, {
                                    action: action
                                }, action._id);
                            }
                            return null;
                        })
                    });
                }
            }),
            projectSlug && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProjectModal/* default */.Z, {
                projectSlug: projectSlug,
                onClose: function() {
                    router.push("/government?governmentSlug=".concat(governmentSlug, "&content=actions"), "/governments/".concat(governmentSlug, "/actions"));
                }
            })
        ]
    });
}
/* harmony default export */ var government_GovernmentActions = (GovernmentActions);

;// CONCATENATED MODULE: ./lib/mutations/SetGovernmentAwards.ts

function SetGovernmentAwards_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation SetGovernmentAwards($governmentId: ObjectId!, $awards: [ObjectId!]!) {\n    setGovernmentAwards(governmentId: $governmentId, awards: $awards) {\n      _id\n      awards {\n        _id\n        name\n      }\n    }\n  }\n"
    ]);
    SetGovernmentAwards_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var SetGovernmentAwards = ((0,lib/* gql */.Ps)(SetGovernmentAwards_templateObject()));

// EXTERNAL MODULE: ./components/awards/AwardsBox.tsx + 2 modules
var AwardsBox = __webpack_require__(58741);
;// CONCATENATED MODULE: ./components/government/GovernmentAwards.tsx





function GovernmentAwards(param) {
    var government = param.government, onAddLink = param.onAddLink;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
        mutation: SetGovernmentAwards,
        children: function(setAwards) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AwardsBox/* default */.Z, {
                onAddLink: onAddLink,
                awards: government.awards,
                readOnly: !government.viewerIsMember,
                onSubmit: function(values) {
                    return setAwards({
                        variables: {
                            governmentId: government._id,
                            awards: values.awards.map(function(param) {
                                var _id = param._id, objectID = param.objectID;
                                return _id || objectID;
                            })
                        },
                        optimisticResponse: {
                            __typename: "Mutation",
                            setGovernmentAwards: {
                                __typename: "Government",
                                _id: government._id,
                                awards: values.awards.map(function(param) {
                                    var _id = param._id, objectID = param.objectID, name = param.name;
                                    return {
                                        _id: _id || objectID,
                                        name: name
                                    };
                                })
                            }
                        }
                    });
                }
            });
        }
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+web@2.32.25_cmry25ein5ld6qeazx5fxbvqjy/node_modules/@govlaunch/web/index.ts + 112 modules
var web = __webpack_require__(19026);
// EXTERNAL MODULE: ./node_modules/.pnpm/google-map-react@2.2.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/google-map-react/dist/index.modern.js + 1 modules
var index_modern = __webpack_require__(76938);
// EXTERNAL MODULE: ./lib/mutations/ToggleFollow.tsx + 1 modules
var ToggleFollow = __webpack_require__(81177);
// EXTERNAL MODULE: ./lib/utils/getCityType.ts
var getCityType = __webpack_require__(79438);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/fp/get.js
var get = __webpack_require__(48182);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(29452);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(45597);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
;// CONCATENATED MODULE: ./lib/hooks/useFetch.ts



function useFetch(url, options) {
    var ref = (0,react.useState)(null), response = ref[0], setResponse = ref[1];
    var ref1 = (0,react.useState)(null), error = ref1[0], setError = ref1[1];
    var ref2 = (0,react.useState)(false), loading = ref2[0], setLoading = ref2[1];
    (0,react.useEffect)(function() {
        var fetchData = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var res, json;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            setLoading(true);
                            _ctx.next = 4;
                            return fetch(url, options);
                        case 4:
                            res = _ctx.sent;
                            _ctx.next = 7;
                            return res.json();
                        case 7:
                            json = _ctx.sent;
                            setResponse(json);
                            setLoading(false);
                            _ctx.next = 15;
                            break;
                        case 12:
                            _ctx.prev = 12;
                            _ctx.t0 = _ctx["catch"](0);
                            setError(_ctx.t0);
                        case 15:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        12
                    ]
                ]);
            }));
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchData();
    }, []);
    return {
        response: response,
        error: error,
        loading: loading
    };
};

;// CONCATENATED MODULE: ./components/Geocode.tsx


function Geocode(param) {
    var location = param.location, children = param.children;
    var ref = useFetch("https://maps.google.com/maps/api/geocode/json?key=".concat("AIzaSyCVTQaQM5yOnSXFWAxfz-uJtp-F2f2bO6Q", "&address=").concat(encodeURIComponent(location))), response = ref.response, error = ref.error, loading = ref.loading;
    var coordinates = get_default()([
        "results",
        0,
        "geometry",
        "location"
    ], response);
    return children({
        coordinates: coordinates,
        error: error,
        loading: loading
    });
};

// EXTERNAL MODULE: ./components/government/GovernmentBudget.tsx
var GovernmentBudget = __webpack_require__(47128);
;// CONCATENATED MODULE: ./lib/mutations/LeaveGroupAsGovernment.ts

function LeaveGroupAsGovernment_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation LeaveGroupAsGovernment($groupId: ObjectId!) {\n    leaveGroupAsGovernment(groupId: $groupId)\n  }\n"
    ]);
    LeaveGroupAsGovernment_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var LeaveGroupAsGovernment = ((0,lib/* gql */.Ps)(LeaveGroupAsGovernment_templateObject()));

;// CONCATENATED MODULE: ./components/government/GovernmentGroups.tsx








function GovernmentGroups(param) {
    var government = param.government;
    var intl = (0,useIntl/* default */.Z)();
    var groups = government.groups;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: {
            backgroundColor: palette/* white */.ix,
            borderTop: "solid 1px ".concat(palette/* lightestGray */.v2),
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    padding: 16,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between"
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                    css: {
                        textTransform: "uppercase",
                        fontSize: 12,
                        color: palette/* sealBlue */.N9,
                        letterSpacing: 0.5,
                        fontWeight: 500
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                        defaultMessage: "Groups",
                        id: "hzmswI"
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    padding: 16,
                    paddingTop: 0
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
                    mutation: LeaveGroupAsGovernment,
                    children: function(leaveGroup, param) {
                        var loading = param.loading;
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: {
                                display: "grid",
                                gridRowGap: 16
                            },
                            children: groups.map(function(group) {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                    passHref: true,
                                    href: "/groups/[groupSlug]",
                                    as: "/groups/".concat(group.slug),
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
                                        css: {
                                            position: "relative",
                                            display: "flex",
                                            alignItems: "center",
                                            width: "100%"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                css: {
                                                    position: "relative"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                        role: "button",
                                                        css: {
                                                            cursor: "pointer",
                                                            position: "absolute",
                                                            top: -5,
                                                            zIndex: 10,
                                                            display: "inline-flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            borderRadius: "100%",
                                                            right: -5,
                                                            width: 16,
                                                            height: 16,
                                                            background: palette/* red */.Q6
                                                        },
                                                        onClick: function(event) {
                                                            event.preventDefault();
                                                            if (!loading) {
                                                                var message = intl.formatMessage({
                                                                    defaultMessage: "Are you sure you want to remove this group for {governmentName}?",
                                                                    id: "wfVQdU"
                                                                }, {
                                                                    governmentName: government.name
                                                                });
                                                                if (window.confirm(message)) {
                                                                    leaveGroup({
                                                                        variables: {
                                                                            groupId: group._id
                                                                        }
                                                                    });
                                                                }
                                                            }
                                                        },
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
                                                            width: 10,
                                                            height: 10,
                                                            viewBox: "0 0 10 10",
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                                                fill: "#FFF",
                                                                d: "M6.188 5l3.566-3.565A.84.84 0 1 0 8.565.246L5 3.812 1.435.246A.84.84 0 1 0 .246 1.435L3.812 5 .246 8.565a.84.84 0 0 0 1.189 1.189L5 6.188l3.565 3.566a.84.84 0 1 0 1.189-1.189L6.188 5z"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(profile_picture/* default */.Z, {
                                                        image: group.logo,
                                                        name: group.name,
                                                        size: 40
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                css: {
                                                    color: palette/* darkGray */.O5,
                                                    marginLeft: 8,
                                                    textOverflow: "ellipsis",
                                                    overflow: "hidden"
                                                },
                                                children: group.name
                                            })
                                        ]
                                    })
                                }, group._id);
                            })
                        });
                    }
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/government/GovernmentPopulation.tsx
var GovernmentPopulation = __webpack_require__(20838);
// EXTERNAL MODULE: ./lib/utils/getHostname.ts
var getHostname = __webpack_require__(6044);
// EXTERNAL MODULE: ./components/icons/CompassIcon.tsx
var CompassIcon = __webpack_require__(76745);
;// CONCATENATED MODULE: ./components/government/GovernmentWebsite.tsx







function GovernmentWebsite(param) {
    var url = param.url;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: {
            display: "flex",
            alignItems: "center"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompassIcon/* default */.Z, {
                width: 38,
                height: 38
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    marginLeft: 10
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                        css: {
                            fontWeight: 600,
                            fontSize: 14,
                            display: "flex"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Website",
                            id: "JkLHGw"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                        href: url,
                        external: "outside-govlaunch",
                        css: {
                            color: palette/* sealBlue */.N9,
                            userSelect: "none",
                            fontSize: 14,
                            "&:focus, &:visited": {
                                color: palette/* darkGray */.O5
                            },
                            "&:hover": {
                                color: palette/* darkGray */.O5,
                                borderBottom: "solid 1px ".concat(palette/* sealBlue */.N9)
                            }
                        },
                        children: (0,getHostname/* default */.Z)(url)
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(38975);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(94614);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(56262);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/fp/omit.js
var omit = __webpack_require__(53104);
var omit_default = /*#__PURE__*/__webpack_require__.n(omit);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/fp/filter.js
var filter = __webpack_require__(54192);
var filter_default = /*#__PURE__*/__webpack_require__.n(filter);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/fp/identity.js
var identity = __webpack_require__(85579);
var identity_default = /*#__PURE__*/__webpack_require__.n(identity);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-use@17.4.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-use/esm/useToggle.js
var useToggle = __webpack_require__(35150);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-switch@6.1.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-switch/index.js
var react_switch = __webpack_require__(86029);
;// CONCATENATED MODULE: ./lib/mutations/SaveGovernmentSharing.ts

function SaveGovernmentSharing_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation SaveGovernmentSharing($governmentSlug: String!, $sharing: GovernmentSharingInput, $enableSharing: Boolean!) {\n    saveGovernmentSharing(governmentSlug: $governmentSlug, enableSharing: $enableSharing, sharing: $sharing) {\n      _id\n      enableSharing\n      sharing {\n        team\n        productStack\n        projects\n        stories\n        resources\n      }\n    }\n  }\n"
    ]);
    SaveGovernmentSharing_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var SaveGovernmentSharing = ((0,lib/* gql */.Ps)(SaveGovernmentSharing_templateObject()));

;// CONCATENATED MODULE: ./components/government/SharingSettingsModal.tsx

















var SharingSettingsModal = function(_param) {
    var handleSetSharing = function handleSetSharing(toggleEnableSharing) {
        return function(options) {
            if (filter_default()((identity_default()), options).length === 0) {
                toggleEnableSharing();
            }
            setSharing(options);
        };
    };
    var government = _param.government, isOpen = _param.isOpen, onRequestClose = _param.onRequestClose, props = (0,_object_without_properties/* default */.Z)(_param, [
        "government",
        "isOpen",
        "onRequestClose"
    ]);
    var intl = (0,useIntl/* default */.Z)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,useToggle/* default */.Z)(government.enableSharing || false), 2), enableSharing = ref[0], toggleEnableSharing = ref[1];
    var ref1 = (0,react.useState)(omit_default()([
        "__typename"
    ], government.sharing)), sharing = ref1[0], setSharing = ref1[1];
    var ref2 = (0,react.useState)(false), saving = ref2[0], setSaving = ref2[1];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(core/* Modal */.u_, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        isOpen: isOpen,
        onRequestClose: function() {
            if (!saving) {
                onRequestClose();
            }
        },
        ariaHideApp: false,
        overlayStyle: {
            background: "rgba(255, 255, 255, 0.6)"
        },
        style: {
            boxShadow: "0 0 20px 0 #e1e1e1",
            border: null
        },
        children: [
            isOpen && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* BlockBodyOverflow */.Bm, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* ModalClose */.A3, {
                onClick: onRequestClose,
                style: {
                    cursor: "pointer"
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    padding: 20,
                    width: 450
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: {
                        display: "grid",
                        rowGap: 15
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                css: {
                                    display: "flex",
                                    justifyContent: "space-between"
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("h3", {
                                    css: {
                                        display: "flex",
                                        alignItems: "center",
                                        color: palette/* darkGray */.O5,
                                        margin: 0,
                                        fontWeight: 500,
                                        fontSize: 21
                                    },
                                    children: [
                                        "Sharing",
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                            css: {
                                                marginLeft: 5,
                                                fontSize: 14,
                                                color: enableSharing ? "#178B61" : "#B44F4F"
                                            },
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_switch["default"], {
                                                uncheckedIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                    css: {
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        height: "100%",
                                                        fontSize: 15,
                                                        color: palette/* lightRed */.r6,
                                                        paddingRight: 10
                                                    },
                                                    children: "off"
                                                }),
                                                checkedIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                    css: {
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        height: "100%",
                                                        fontSize: 15,
                                                        color: "#fff",
                                                        paddingLeft: 10
                                                    },
                                                    children: "on"
                                                }),
                                                handleDiameter: 22,
                                                height: 26,
                                                width: 65,
                                                onChange: function(checked) {
                                                    toggleEnableSharing();
                                                    if (checked) {
                                                        setSharing({
                                                            productStack: true,
                                                            team: true,
                                                            projects: true,
                                                            stories: true,
                                                            resources: true,
                                                            awards: true
                                                        });
                                                    } else {
                                                        setSharing({});
                                                    }
                                                },
                                                checked: enableSharing,
                                                onColor: palette/* greenSuccess */.CU,
                                                offColor: palette/* red */.Q6
                                            })
                                        })
                                    ]
                                })
                            })
                        }),
                        enableSharing ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
                            css: {
                                color: palette/* darkGray */.O5,
                                fontSize: 14,
                                margin: 0
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Select the items below to display in your public share page",
                                    id: "6kIwcu"
                                }),
                                ": ",
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                    css: {
                                        color: "#005AEE"
                                    },
                                    href: getSharingUrl(government.slug),
                                    rel: "noopener noreferrer",
                                    target: "_blank",
                                    children: getSharingUrl(government.slug)
                                })
                            ]
                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
                            css: {
                                color: palette/* darkGray */.O5,
                                fontSize: 14,
                                margin: 0
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Turn on sharing to create your custom page and then select what you want to share. It is that simple! Your Government’s unique URL",
                                    id: "e3npfa"
                                }),
                                ": ",
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                    css: {
                                        color: "#005AEE"
                                    },
                                    href: getSharingUrl(government.slug),
                                    rel: "noopener noreferrer",
                                    target: "_blank",
                                    children: getSharingUrl(government.slug)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
                                    css: {
                                        color: palette/* darkGray */.O5,
                                        fontSize: 14,
                                        margin: 0,
                                        marginBottom: 5
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("strong", {
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                    defaultMessage: "Public",
                                                    id: "uhu5aG"
                                                }),
                                                ":"
                                            ]
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Anybody can view (including guests in Govlaunch)",
                                            id: "dF5LfH"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
                                    css: {
                                        color: palette/* darkGray */.O5,
                                        fontSize: 14,
                                        margin: 0
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("strong", {
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                    defaultMessage: "Private",
                                                    id: "viXE32"
                                                }),
                                                ":"
                                            ]
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Only verified users of the Govlaunch community can view",
                                            id: "bQmHhu"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: {
                                opacity: enableSharing ? 1 : 0.3,
                                display: "grid",
                                rowGap: 10
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Toggle, {
                                    value: "stories",
                                    description: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                defaultMessage: "Stories",
                                                id: "Ldxym4"
                                            }),
                                            ":",
                                            " ",
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                                css: {
                                                    fontSize: 11
                                                },
                                                children: [
                                                    "(",
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                        defaultMessage: "only stories marked as public will be visible",
                                                        id: "UPxtYU"
                                                    }),
                                                    ")"
                                                ]
                                            })
                                        ]
                                    }),
                                    sharing: sharing,
                                    setSharing: handleSetSharing(toggleEnableSharing),
                                    enableSharing: enableSharing
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Toggle, {
                                    value: "projects",
                                    description: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                defaultMessage: "Projects",
                                                id: "UxTJRa"
                                            }),
                                            ":",
                                            " ",
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                                css: {
                                                    fontSize: 11
                                                },
                                                children: [
                                                    "(",
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                        defaultMessage: "only projects marked as public will be visible",
                                                        id: "8uWZ5k"
                                                    }),
                                                    ")"
                                                ]
                                            })
                                        ]
                                    }),
                                    sharing: sharing,
                                    setSharing: handleSetSharing(toggleEnableSharing),
                                    enableSharing: enableSharing
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Toggle, {
                                    value: "productStack",
                                    description: intl.formatMessage({
                                        defaultMessage: "Product stack",
                                        id: "rNSOQE"
                                    }),
                                    sharing: sharing,
                                    setSharing: handleSetSharing(toggleEnableSharing),
                                    enableSharing: enableSharing
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Toggle, {
                                    value: "resources",
                                    description: intl.formatMessage({
                                        defaultMessage: "Resources",
                                        id: "c/KktL"
                                    }),
                                    sharing: sharing,
                                    setSharing: handleSetSharing(toggleEnableSharing),
                                    enableSharing: enableSharing
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Toggle, {
                                    value: "team",
                                    description: intl.formatMessage({
                                        defaultMessage: "Team Members",
                                        id: "HCYBYT"
                                    }),
                                    sharing: sharing,
                                    setSharing: handleSetSharing(toggleEnableSharing),
                                    enableSharing: enableSharing
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Toggle, {
                                    value: "awards",
                                    description: intl.formatMessage({
                                        defaultMessage: "Awards",
                                        id: "FqvBgl"
                                    }),
                                    sharing: sharing,
                                    setSharing: handleSetSharing(toggleEnableSharing),
                                    enableSharing: enableSharing
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
                            mutation: SaveGovernmentSharing,
                            children: function(saveGovernmentSharing) {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                                    disabled: saving,
                                    size: "small",
                                    color: palette/* innovatorBlue */.LD,
                                    css: {
                                        userSelect: "none",
                                        marginTop: 10
                                    },
                                    onClick: function() {
                                        setSaving(true);
                                        saveGovernmentSharing({
                                            variables: {
                                                governmentSlug: government.slug,
                                                sharing: sharing,
                                                enableSharing: enableSharing
                                            }
                                        }).then(function() {
                                            setSaving(false);
                                            onRequestClose();
                                        });
                                    },
                                    children: saving ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "Saving",
                                        id: "QLkzoS"
                                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "Save",
                                        id: "jvo0vs"
                                    })
                                });
                            }
                        })
                    ]
                })
            })
        ]
    }));
};
var Toggle = function(param) {
    var value = param.value, description = param.description, sharing = param.sharing, setSharing = param.setSharing, enableSharing = param.enableSharing;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("label", {
            css: {
                display: "flex",
                alignItems: "center"
            },
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_switch["default"], {
                    uncheckedIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: {
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                            fontSize: 10,
                            color: palette/* lightRed */.r6,
                            paddingRight: 15
                        },
                        children: "off"
                    }),
                    checkedIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: {
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                            fontSize: 10,
                            color: "#fff",
                            paddingLeft: 15
                        },
                        children: "on"
                    }),
                    offColor: palette/* red */.Q6,
                    handleDiameter: 22,
                    height: 30,
                    width: 80,
                    onColor: palette/* greenSuccess */.CU,
                    onChange: function() {
                        return setSharing(omit_default()("__typename", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sharing), (0,_define_property/* default */.Z)({}, value, !sharing[value]))));
                    },
                    checked: enableSharing && Boolean(sharing[value])
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                    css: {
                        marginLeft: 10,
                        color: palette/* darkGray */.O5,
                        fontSize: 16
                    },
                    children: description
                })
            ]
        })
    });
};
function getSharingUrl(slug) {
    if (true) {
        return "https://".concat(slug, ".govlaunch.com");
    }
    if (false) {}
    return "http://localhost:3004/".concat(slug);
}
/* harmony default export */ var government_SharingSettingsModal = (SharingSettingsModal);

;// CONCATENATED MODULE: ./components/government/GovernmentInfo.tsx






















function GovernmentInfo(param) {
    var government = param.government, content = param.content, user = param.user;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        "data-intercom-target": government.viewerIsMember ? "Government Details" : null,
        css: {
            backgroundColor: palette/* white */.ix,
            border: "solid 1px ".concat(palette/* lightestGray */.v2),
            borderRadius: 5,
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(government_SharingSettingsModal, {
                government: government,
                isOpen: content === "sharing",
                onRequestClose: function() {
                    return router.push("/governments/[governmentSlug]/[[...content]]", "/governments/".concat(government.slug, "/settings"));
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                    padding: 16
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                        href: "/governments/[governmentSlug]/[[...content]]",
                        as: "/governments/".concat(government.slug),
                        passHref: true,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                            css: {
                                color: "unset",
                                textDecoration: "none",
                                display: "flex",
                                alignItems: "center"
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(profile_picture/* default */.Z, {
                                size: 80,
                                name: government.name,
                                image: government.logo,
                                innovator: government.isInnovator
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h1", {
                                css: {
                                    fontSize: 24,
                                    color: palette/* text */.fL,
                                    fontWeight: "bold",
                                    lineHeight: 1.44,
                                    margin: 0,
                                    textAlign: "center"
                                },
                                children: government.name
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                css: {
                                    fontSize: 14,
                                    color: palette/* mediumGray */.rF,
                                    fontWeight: 600,
                                    textAlign: "center"
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "{cityType} in {stateName}",
                                    id: "wh7SV3",
                                    values: {
                                        cityType: (0,getCityType/* default */.Z)(government.city.governmentType || ""),
                                        stateName: government.city.state
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                py: 2,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* CountryFlag */.AW, {
                                        countryCode: government.city.country,
                                        width: 24,
                                        height: 14
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                        css: {
                                            fontSize: 14,
                                            marginLeft: 8,
                                            color: palette/* mediumGray */.rF,
                                            fontWeight: 600,
                                            textAlign: "center"
                                        },
                                        children: government.city.countryName
                                    })
                                ]
                            }),
                            Number(government.budget) > 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                css: {
                                    fontSize: 12,
                                    color: palette/* sealBlue */.N9,
                                    fontWeight: 500,
                                    display: "flex",
                                    marginTop: 4,
                                    justifyContent: "center"
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GovernmentPopulation/* default */.Z, {
                                        population: government.city.population || 0
                                    }),
                                    "\xa0",
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        id: "Hmd2rc",
                                        defaultMessage: "population"
                                    }),
                                    "\xa0• ",
                                    (0,GovernmentBudget/* getFormattedBudget */.L)(government.budget || 0, government.currency),
                                    " ",
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "budget",
                                        id: "iBmHR/"
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                css: {
                                    fontSize: 12,
                                    color: palette/* sealBlue */.N9,
                                    fontWeight: 500,
                                    display: "flex",
                                    marginTop: 4,
                                    justifyContent: "center"
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GovernmentPopulation/* default */.Z, {
                                        population: government.city.population || 0
                                    }),
                                    "\xa0",
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        id: "Hmd2rc",
                                        defaultMessage: "population"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            user && user.canSeeActiveGovernments && !government.viewerIsMember && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(spacings/* Margin */.Zt, {
                mb: 16,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                        mb: 16,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: {
                                height: 1,
                                width: "100%",
                                backgroundColor: palette/* lightestSealBlue */.ks
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: {
                            display: "flex",
                            justifyContent: "center"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FollowButton, {
                            government: government
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Geocode, {
                location: government.city.zip || government.city.county ? [
                    government.city.name,
                    government.city.county,
                    government.city.zip
                ].filter(Boolean).join(" ") : government.city.name,
                children: function(param) {
                    var coordinates = param.coordinates, loading = param.loading;
                    if (loading || !coordinates) {
                        return null;
                    }
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: {
                            width: "100%",
                            height: 270
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_modern/* default */.ZP, {
                            bootstrapURLKeys: {
                                key: "AIzaSyCVTQaQM5yOnSXFWAxfz-uJtp-F2f2bO6Q" || 0
                            },
                            defaultCenter: coordinates,
                            defaultZoom: 12,
                            options: {
                                styles: [
                                    {
                                        featureType: "all",
                                        elementType: "all",
                                        stylers: [
                                            {
                                                hue: "#e7ecf0"
                                            }, 
                                        ]
                                    },
                                    {
                                        featureType: "poi",
                                        elementType: "all",
                                        stylers: [
                                            {
                                                visibility: "off"
                                            }, 
                                        ]
                                    },
                                    {
                                        featureType: "road",
                                        elementType: "all",
                                        stylers: [
                                            {
                                                saturation: -70
                                            }, 
                                        ]
                                    },
                                    {
                                        featureType: "transit",
                                        elementType: "all",
                                        stylers: [
                                            {
                                                visibility: "off"
                                            }, 
                                        ]
                                    },
                                    {
                                        featureType: "water",
                                        elementType: "all",
                                        stylers: [
                                            {
                                                visibility: "simplified"
                                            },
                                            {
                                                saturation: -60
                                            }, 
                                        ]
                                    }, 
                                ]
                            }
                        })
                    });
                }
            }),
            government.site && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    padding: 16
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GovernmentWebsite, {
                    url: government.site
                })
            }),
            government.viewerIsMember && government.groups.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GovernmentGroups, {
                government: government
            })
        ]
    });
};
var FollowButton = function(param) {
    var government = param.government;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Hover */.TM, {
        children: function(param) {
            var hovered = param.hovered, bind = param.bind;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    display: "flex",
                    justifyContent: "center"
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToggleFollow/* default */.Z, {
                    targetId: government._id,
                    entityType: "Government",
                    viewerIsFollowing: government.isFollowing,
                    children: function(param) {
                        var toggle = param.toggle;
                        if (!government.isFollowing) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                theme: "primary",
                                size: "xsmall",
                                onClick: toggle
                            }, bind), {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Follow",
                                    id: "ieGrWo"
                                })
                            }));
                        }
                        if (!hovered) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                theme: "primary",
                                size: "xsmall",
                                onClick: toggle
                            }, bind), {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Following",
                                    id: "cPIKU2"
                                })
                            }));
                        }
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            theme: "primary",
                            color: palette/* red */.Q6,
                            textColor: palette/* white */.ix,
                            size: "xsmall",
                            onClick: toggle
                        }, bind), {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "Unfollow",
                                id: "izWS4J"
                            })
                        }));
                    }
                })
            });
        }
    });
};

// EXTERNAL MODULE: ./lib/mutations/SetProfileCover.tsx + 1 modules
var SetProfileCover = __webpack_require__(76198);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/fp/getOr.js
var getOr = __webpack_require__(62076);
var getOr_default = /*#__PURE__*/__webpack_require__.n(getOr);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-final-form@6.5.9_s44h3cxpdxv6cks4bnqewerqda/node_modules/react-final-form/dist/react-final-form.es.js
var react_final_form_es = __webpack_require__(56225);
// EXTERNAL MODULE: ./components/form/FieldValidationError.tsx
var FieldValidationError = __webpack_require__(80360);
;// CONCATENATED MODULE: ./components/government/utils/getCurrencySignal.ts
var CURRENCY_SIGNALS = {
    USD: "$",
    GBP: "\xa3",
    CAD: "CA$",
    AUD: "AU$",
    NZD: "NZ$",
    ZAR: "R"
};
function getCurrencySignal(code) {
    return CURRENCY_SIGNALS[code] || "";
};

// EXTERNAL MODULE: ./node_modules/.pnpm/yup@0.32.11/node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(55423);
// EXTERNAL MODULE: ./lib/utils/validate.ts
var validate = __webpack_require__(32774);
;// CONCATENATED MODULE: ./lib/mutations/UpdateGovernmentProfile.ts

function UpdateGovernmentProfile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation UpdateGovernmentProfile($governmentId: ObjectId!, $government: UpdateGovernmentProfileInput!) {\n    updateGovernmentProfile(governmentId: $governmentId, government: $government) {\n      _id\n      site\n      budget\n      logo\n    }\n  }\n"
    ]);
    UpdateGovernmentProfile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var UpdateGovernmentProfile = ((0,lib/* gql */.Ps)(UpdateGovernmentProfile_templateObject()));

;// CONCATENATED MODULE: ./components/government/GovernmentProfileForm.tsx




















var validationSchema = es/* object */.Ry().shape({
    site: es/* string */.Z_().nullable().url("Invalid URL").trim(),
    budget: es/* number */.Rx().nullable(),
    population: es/* number */.Rx().nullable()
});
function GovernmentProfileForm(param) {
    var government = param.government;
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
        mutation: UpdateGovernmentProfile,
        refetchQueries: [
            "Government"
        ],
        update: function(proxy, param) {
            var data = param.data;
            if (!data || !data.updateGovernmentProfile) {
                return;
            }
            var showCompleteGovernmentProfileBanner = !(data.updateGovernmentProfile.logo && data.updateGovernmentProfile.budget && data.updateGovernmentProfile.site);
            var selfieQuery = proxy.readQuery({
                query: SelfieQuery/* default */.Z,
                variables: {
                    token: null
                }
            });
            if (!selfieQuery || !selfieQuery.selfie || selfieQuery.selfie.__typename !== "GovernmentUser") {
                return;
            }
            proxy.writeQuery({
                query: SelfieQuery/* default */.Z,
                data: {
                    __typename: "Query",
                    selfie: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, selfieQuery.selfie), {
                        showCompleteGovernmentProfileBanner: showCompleteGovernmentProfileBanner
                    })
                }
            });
        },
        children: function(updateGovernmentProfile) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Form */.l0, {
                initialValues: {
                    logo: government.logo,
                    site: government.site,
                    budget: government.budget,
                    population: government.city.population
                },
                validate: (0,validate/* default */.Z)(validationSchema),
                subscription: {
                    submitting: true,
                    invalid: true
                },
                onSubmit: function(values) {
                    return updateGovernmentProfile({
                        variables: {
                            governmentId: government._id,
                            government: {
                                site: values.site || null,
                                budget: values.budget || null,
                                logo: values.logo || null,
                                population: values.population || null
                            }
                        }
                    });
                },
                children: function(param) {
                    var handleSubmit = param.handleSubmit, submitting = param.submitting;
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("form", {
                        onSubmit: handleSubmit,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                css: {
                                    position: "relative"
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SetProfileCover/* default */.Z, {
                                        entityType: "Government",
                                        targetId: government._id,
                                        children: function(param) {
                                            var onSetProfileCover = param.onSetProfileCover, onSetRepositionedCover = param.onSetRepositionedCover, onRemoveCover = param.onRemoveCover;
                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Cover/* default */.ZP, {
                                                alt: "Cover",
                                                height: 250,
                                                originalSource: getOr_default()(null, "cover.original", government),
                                                repositionedSource: getOr_default()(null, "cover.repositioned", government),
                                                placeholderSource: Cover/* PLACEHOLDER_COVER */.t2,
                                                onReposition: function(originalSource, cropState) {
                                                    var repositionedSource = (0,Cover/* makeImaginaryUrls */.oH)(originalSource, cropState);
                                                    onSetRepositionedCover(originalSource, repositionedSource.cropped, cropState);
                                                },
                                                onChange: onSetProfileCover,
                                                onRemove: onRemoveCover,
                                                readOnly: false,
                                                containerProps: {
                                                    style: {
                                                        borderRadius: 5,
                                                        overflow: "hidden"
                                                    }
                                                }
                                            });
                                        }
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        css: {
                                            position: "absolute",
                                            top: "50%",
                                            marginTop: -30,
                                            left: "50%",
                                            transform: "translate(-50%, -50%)"
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
                                            name: "logo",
                                            children: function(param) {
                                                var input = param.input;
                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Filestack */.QZ, {
                                                    onSuccess: function(param) {
                                                        var filesUploaded = param.filesUploaded;
                                                        return input.onChange(filesUploaded[0].url);
                                                    },
                                                    customRender: function(param) {
                                                        var onPick = param.onPick;
                                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                                    css: {
                                                                        display: "flex",
                                                                        justifyContent: "center"
                                                                    },
                                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(profile_picture/* default */.Z, {
                                                                        xlarge: true,
                                                                        image: input.value,
                                                                        name: government.name || "A B"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                                    css: {
                                                                        display: "grid",
                                                                        gridAutoFlow: "column",
                                                                        gridAutoColumns: "max-content",
                                                                        justifyContent: "center",
                                                                        gridColumnGap: 5,
                                                                        marginTop: 16
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                                                                            size: "xsmall",
                                                                            color: palette/* primary */.T$,
                                                                            onClick: onPick,
                                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                                                defaultMessage: "Upload",
                                                                                id: "p4N05H"
                                                                            })
                                                                        }),
                                                                        input.value && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                                                                            size: "xsmall",
                                                                            color: palette/* red */.Q6,
                                                                            theme: "secondary",
                                                                            css: {
                                                                                background: "#fff"
                                                                            },
                                                                            onClick: function() {
                                                                                return input.onChange(null);
                                                                            },
                                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                                                defaultMessage: "Remove",
                                                                                id: "G/yZLu"
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        });
                                                    }
                                                });
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                css: {
                                    border: "1px solid ".concat(palette/* lightestGray */.v2),
                                    borderRadius: 4,
                                    marginTop: 24,
                                    background: "#fff"
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        css: {
                                            borderBottom: "1px solid ".concat(palette/* lightestGray */.v2),
                                            padding: 16,
                                            fontSize: 14,
                                            fontWeight: 500,
                                            color: palette/* sealBlue */.N9
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Profile",
                                            id: "itPgxd"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                        css: {
                                            padding: 16,
                                            display: "grid",
                                            gridRowGap: 16
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
                                                name: "site",
                                                children: function(param) {
                                                    var input = param.input, meta = param.meta;
                                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                                css: {
                                                                    display: "flex",
                                                                    alignItems: "center"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("label", {
                                                                        css: {
                                                                            fontWeight: 500,
                                                                            fontSize: 14,
                                                                            color: palette/* mediumGray */.rF,
                                                                            margin: 0
                                                                        },
                                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                                            defaultMessage: "Website",
                                                                            id: "JkLHGw"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FieldValidationError/* default */.Z, {
                                                                        meta: meta
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                                                mt: 12,
                                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", (0,_object_spread/* default */.Z)({
                                                                    placeholder: intl.formatMessage({
                                                                        defaultMessage: "Type government website",
                                                                        id: "ulRgSs"
                                                                    }),
                                                                    maxLength: 80,
                                                                    css: {
                                                                        width: "100%",
                                                                        height: 42,
                                                                        padding: "6px 12px",
                                                                        fontSize: 14,
                                                                        border: "solid 1px ".concat(palette/* lightestGray */.v2),
                                                                        borderRadius: 6,
                                                                        outline: 0,
                                                                        ":focus": {
                                                                            borderColor: palette/* primary */.T$
                                                                        },
                                                                        "::placeholder": {
                                                                            color: palette/* sealBlue */.N9
                                                                        }
                                                                    }
                                                                }, input))
                                                            })
                                                        ]
                                                    });
                                                }
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
                                                name: "budget",
                                                format: function(value) {
                                                    return "".concat(getCurrencySignal(government.currency), " ").concat(value || 0).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                                },
                                                parse: function(value) {
                                                    return value.toString().replace(/([^\d]+)/g, "").length > 0 ? parseInt(value.replace(/([^\d]+)/g, "")) : 0;
                                                },
                                                children: function(param) {
                                                    var input = param.input, meta = param.meta;
                                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                                css: {
                                                                    display: "flex",
                                                                    alignItems: "center"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("label", {
                                                                        css: {
                                                                            fontWeight: 500,
                                                                            fontSize: 14,
                                                                            color: palette/* mediumGray */.rF,
                                                                            margin: 0
                                                                        },
                                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                                            defaultMessage: "Budget",
                                                                            id: "0KKXrH"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FieldValidationError/* default */.Z, {
                                                                        meta: meta
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                                                mt: 12,
                                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", (0,_object_spread/* default */.Z)({
                                                                    placeholder: intl.formatMessage({
                                                                        defaultMessage: "What's the government budget?",
                                                                        id: "/ME8C4"
                                                                    }),
                                                                    maxLength: 80,
                                                                    css: {
                                                                        width: "100%",
                                                                        height: 42,
                                                                        padding: "6px 12px",
                                                                        fontSize: 14,
                                                                        border: "solid 1px ".concat(palette/* lightestGray */.v2),
                                                                        borderRadius: 6,
                                                                        outline: 0,
                                                                        ":focus": {
                                                                            borderColor: palette/* primary */.T$
                                                                        },
                                                                        "::placeholder": {
                                                                            color: palette/* sealBlue */.N9
                                                                        }
                                                                    }
                                                                }, input))
                                                            })
                                                        ]
                                                    });
                                                }
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
                                                name: "population",
                                                format: function(value) {
                                                    return "".concat(value || "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                                },
                                                parse: function(value) {
                                                    return value.toString().replace(/([^\d]+)/g, "").length > 0 ? parseInt(value.replace(/([^\d]+)/g, "")) : 0;
                                                },
                                                children: function(param) {
                                                    var input = param.input, meta = param.meta;
                                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                                css: {
                                                                    display: "flex",
                                                                    alignItems: "center"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("label", {
                                                                        css: {
                                                                            fontWeight: 500,
                                                                            fontSize: 14,
                                                                            color: palette/* mediumGray */.rF,
                                                                            margin: 0
                                                                        },
                                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                                            defaultMessage: "Population",
                                                                            id: "+EKK8l"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FieldValidationError/* default */.Z, {
                                                                        meta: meta
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                                                mt: 12,
                                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", (0,_object_spread/* default */.Z)({
                                                                    placeholder: intl.formatMessage({
                                                                        defaultMessage: "What's the government population?",
                                                                        id: "9sAygw"
                                                                    }),
                                                                    maxLength: 80,
                                                                    css: {
                                                                        width: "100%",
                                                                        height: 42,
                                                                        padding: "6px 12px",
                                                                        fontSize: 14,
                                                                        border: "solid 1px ".concat(palette/* lightestGray */.v2),
                                                                        borderRadius: 6,
                                                                        outline: 0,
                                                                        ":focus": {
                                                                            borderColor: palette/* primary */.T$
                                                                        },
                                                                        "::placeholder": {
                                                                            color: palette/* sealBlue */.N9
                                                                        }
                                                                    }
                                                                }, input))
                                                            })
                                                        ]
                                                    });
                                                }
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                css: {
                                                    display: "flex",
                                                    justifyContent: "flex-end"
                                                },
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                                                    type: "submit",
                                                    disabled: submitting,
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                        defaultMessage: "Save",
                                                        id: "jvo0vs"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    });
                }
            });
        }
    });
};

// EXTERNAL MODULE: ./lib/hooks/useShowMoreCounter.ts
var useShowMoreCounter = __webpack_require__(87386);
// EXTERNAL MODULE: ./components/story/StoryListItemDividers.tsx
var StoryListItemDividers = __webpack_require__(77966);
// EXTERNAL MODULE: ./components/story/StoryListItemHoverContainer.tsx
var StoryListItemHoverContainer = __webpack_require__(59933);
// EXTERNAL MODULE: ./components/story/StoryListItem.tsx + 3 modules
var StoryListItem = __webpack_require__(92136);
;// CONCATENATED MODULE: ./components/government/GovernmentStories.tsx










function GovernmentStories(param) {
    var stories = param.stories;
    var ref = (0,useShowMoreCounter/* default */.Z)(stories.length, 4), offset = ref.offset, showMore = ref.showMore, hasMore = ref.hasMore;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: {
            backgroundColor: palette/* white */.ix,
            borderRadius: 5,
            border: "solid 1px ".concat(palette/* lightestGray */.v2)
        },
        "data-intercom-target": "Government Stories",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryListItemDividers/* default */.Z, {
                children: stories.slice(0, offset).map(function(story) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryListItemHoverContainer/* default */.Z, {
                        style: {
                            padding: 15
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryListItem/* default */.Z, {
                            story: story
                        })
                    }, story._id);
                })
            }),
            hasMore && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ShowMore, {
                onClick: showMore
            })
        ]
    });
};
var ShowMore = function(props) {
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        role: "button",
        "aria-label": intl.formatMessage({
            defaultMessage: "View More",
            id: "QQSdHP"
        }),
        css: {
            padding: 15,
            textTransform: "uppercase",
            color: palette/* sealBlue */.N9,
            fontSize: 12,
            textAlign: "center",
            fontWeight: 500,
            cursor: "pointer",
            borderTop: "solid 1px ".concat(palette/* lightestGray */.v2),
            "&:hover": {
                color: palette/* darkGray */.O5
            }
        }
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
            defaultMessage: "View More",
            id: "QQSdHP"
        })
    }));
};

;// CONCATENATED MODULE: ./lib/mutations/UpdateGovernmentSettings.ts

function UpdateGovernmentSettings_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation UpdateGovernmentSettings($governmentId: ObjectId!, $settings: GovernmentSettingsInput!) {\n    updateGovernmentSettings(governmentId: $governmentId, settings: $settings) {\n      _id\n      groups {\n        _id\n        name\n        logo\n      }\n      settings {\n        projectSharingWithGroups {\n          _id\n          name\n          logo\n        }\n      }\n    }\n  }\n"
    ]);
    UpdateGovernmentSettings_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var UpdateGovernmentSettings = ((0,lib/* gql */.Ps)(UpdateGovernmentSettings_templateObject()));

// EXTERNAL MODULE: ./components/text/Dotdotdot.tsx
var Dotdotdot = __webpack_require__(3552);
;// CONCATENATED MODULE: ./components/government/ProjectSharingWithGroups.tsx









function ProjectSharingWithGroups(param) {
    var government = param.government;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        "data-intercom-target": "Project Sharing with Groups",
        css: {
            backgroundColor: palette/* white */.ix,
            border: "solid 1px ".concat(palette/* lightestGray */.v2),
            borderRadius: 4
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    padding: 16,
                    textTransform: "uppercase",
                    fontSize: 12,
                    borderBottom: "1px solid ".concat(palette/* lightestGray */.v2),
                    color: palette/* sealBlue */.N9,
                    letterSpacing: 0.5,
                    fontWeight: 500,
                    display: "flex",
                    alignItems: "center"
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                    defaultMessage: "Group Project Sharing",
                    id: "KCUJSY"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    display: "grid",
                    gridRowGap: 24,
                    padding: 16
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                        css: {
                            margin: 0,
                            color: palette/* mediumGray */.rF,
                            fontSize: 14,
                            lineHeight: 1.33,
                            letterSpacing: 1
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "By enabling sharing with a Group, all Public and Community projects from your Government will be displayed in the Group. You can disable this at any time.",
                            id: "iPKgNY"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
                        mutation: UpdateGovernmentSettings,
                        children: function(updateGovernmentSettings) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                children: government.groups.map(function(group) {
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                        css: {
                                            display: "grid",
                                            gridTemplateColumns: "48px 1fr max-content",
                                            alignItems: "center",
                                            gridColumnGap: 20
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(profile_picture/* default */.Z, {
                                                size: 48,
                                                image: group.logo,
                                                name: group.name
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dotdotdot/* default */.Z, {
                                                clamp: 1,
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                                    css: {
                                                        margin: 0,
                                                        color: palette/* text */.fL,
                                                        fontSize: 14,
                                                        lineHeight: 1.33
                                                    },
                                                    children: group.name
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_switch["default"], {
                                                uncheckedIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                    css: {
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        height: "100%",
                                                        paddingRight: 20,
                                                        color: palette/* lightRed */.r6,
                                                        fontSize: 12
                                                    },
                                                    children: "off"
                                                }),
                                                checkedIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                    css: {
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        height: "100%",
                                                        paddingLeft: 20,
                                                        color: "#fff",
                                                        fontSize: 12
                                                    },
                                                    children: "on"
                                                }),
                                                offColor: palette/* red */.Q6,
                                                handleDiameter: 22,
                                                height: 24,
                                                width: 80,
                                                onColor: palette/* greenSuccess */.CU,
                                                onChange: function(isChecked) {
                                                    var groups = government.settings.projectSharingWithGroups;
                                                    if (isChecked) {
                                                        groups = groups.concat(group);
                                                    } else {
                                                        groups = groups.filter(function(maybe) {
                                                            return maybe._id !== group._id;
                                                        });
                                                    }
                                                    updateGovernmentSettings({
                                                        variables: {
                                                            governmentId: government._id,
                                                            settings: {
                                                                projectSharingWithGroups: groups.map(function(group) {
                                                                    return group._id;
                                                                })
                                                            }
                                                        }
                                                    });
                                                },
                                                checked: government.settings.projectSharingWithGroups.some(function(maybe) {
                                                    return maybe._id === group._id;
                                                })
                                            })
                                        ]
                                    }, group._id);
                                })
                            });
                        }
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/react-use@17.4.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-use/esm/useLocalStorage.js
var useLocalStorage = __webpack_require__(67969);
;// CONCATENATED MODULE: ./lib/mutations/RequestGovernmentOwnership.ts

function RequestGovernmentOwnership_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation RequestGovernmentOwnership($governmentId: ObjectId) {\n    requestGovernmentOwnership(government: $governmentId)\n  }\n"
    ]);
    RequestGovernmentOwnership_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var RequestGovernmentOwnership = ((0,lib/* gql */.Ps)(RequestGovernmentOwnership_templateObject()));

;// CONCATENATED MODULE: ./components/government/RequestAccess.tsx









function RequestAccess(param) {
    var government = param.government;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useLocalStorage/* default */.Z)("accessRequests", []), 2), requests = ref[0], setRequests = ref[1];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: {
            display: "flex",
            justifyContent: "center"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
            variables: {
                governmentId: government._id
            },
            mutation: RequestGovernmentOwnership,
            onCompleted: function() {
                if (typeof requests !== "undefined") {
                    setRequests(requests.concat([
                        government._id
                    ]));
                }
            },
            children: function(requestAccess, param) {
                var loading = param.loading, called = param.called;
                if (false) {}
                var isButtonDisabled = typeof requests !== "undefined" && (requests.includes(government._id) || called);
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: {
                        padding: 24,
                        borderRadius: 5,
                        border: "1px solid ".concat(palette/* lightestGray */.v2),
                        background: "#fff",
                        display: "grid",
                        gridRowGap: 16,
                        textAlign: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
                            css: {
                                fontSize: 24,
                                color: palette/* darkGray */.O5,
                                fontWeight: 500,
                                margin: 0
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "Join {cityName}?",
                                id: "ZypfVK",
                                values: {
                                    cityName: government.city.name
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                            css: {
                                margin: 0,
                                fontSize: 14,
                                color: palette/* darkGray */.O5
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "Do you represent or work for this local government?",
                                id: "PDL48f"
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                            theme: "secondary",
                            size: "xsmall",
                            onClick: requestAccess,
                            fontSize: isButtonDisabled ? 14 : 16,
                            color: isButtonDisabled ? "disabled" : palette/* innovatorBlue */.LD,
                            disabled: loading || isButtonDisabled,
                            "data-intercom-target": "request access",
                            style: {
                                fontWeight: "bold",
                                maxWidth: 400,
                                margin: "0 auto",
                                textOverflow: "ellipsis",
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                pointerEvents: isButtonDisabled ? "none" : "all"
                            },
                            children: loading ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* LoadingIndicator */.TF, {}) : isButtonDisabled ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "You've requested access to {cityName} \uD83C\uDF89",
                                id: "neqVmr",
                                values: {
                                    cityName: government.city.name
                                }
                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "Request Access",
                                id: "UnR8YN"
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                            css: {
                                margin: 0,
                                fontSize: 12,
                                color: palette/* sealBlue */.N9
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "We may take up to 48 hours to review your request. If you have any questions about this process, <link>contact us</link>",
                                id: "p2yomL",
                                values: {
                                    // eslint-disable-next-line react/display-name
                                    link: function(text) {
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                            css: {
                                                color: palette/* innovatorBlue */.LD
                                            },
                                            href: "mailto:contact@govlaunch.com",
                                            children: text
                                        });
                                    }
                                }
                            })
                        })
                    ]
                });
            }
        })
    });
};

// EXTERNAL MODULE: ./components/icons/GearIcon.tsx
var GearIcon = __webpack_require__(74055);
// EXTERNAL MODULE: ./components/profile/EmptyBlocks.tsx
var EmptyBlocks = __webpack_require__(32796);
// EXTERNAL MODULE: ./lib/hooks/useClipboard.ts
var useClipboard = __webpack_require__(91472);
;// CONCATENATED MODULE: ./components/government/SharingBox.tsx











var SharingBox = function(param) {
    var government = param.government;
    var inputRef = /*#__PURE__*/ react.createRef();
    var ref = (0,_sliced_to_array/* default */.Z)((0,useClipboard/* default */.Z)(inputRef), 2), copied = ref[0], setClipboard = ref[1];
    var router = (0,next_router.useRouter)();
    if (government.enableSharing) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: {
                backgroundColor: palette/* white */.ix,
                borderRadius: 5,
                border: "solid 1px ".concat(palette/* lightestGray */.v2)
            },
            "data-intercom-target": "Government Sharing",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: {
                        padding: 15,
                        textTransform: "uppercase",
                        fontSize: 12,
                        borderBottom: "1px solid ".concat(palette/* lightestGray */.v2),
                        color: palette/* sealBlue */.N9,
                        letterSpacing: 0.5,
                        fontWeight: 500,
                        display: "flex",
                        alignItems: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Sharing",
                            id: "XfKNCg"
                        }),
                        government.viewerIsMember && government.enableSharing && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            role: "button",
                            css: {
                                display: "inline-flex",
                                marginLeft: "auto",
                                cursor: "pointer"
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                href: "/governments/[governmentSlug]/[[...content]]",
                                as: "/governments/".concat(government.slug, "/sharing"),
                                passHref: true,
                                scroll: false,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GearIcon/* default */.Z, {
                                        width: 20,
                                        height: 20
                                    })
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: {
                        padding: 15
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: {
                                fontWeight: 500,
                                fontSize: 14,
                                color: palette/* darkGray */.O5,
                                marginBottom: 15
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "{governmentName}'s custom public page is now live!",
                                id: "Xk+MIK",
                                values: {
                                    governmentName: government.name
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: {
                                fontSize: 14,
                                color: palette/* darkGray */.O5
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                css: {
                                    position: "relative"
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        css: {
                                            position: "absolute",
                                            left: 15,
                                            top: 14,
                                            display: "inline-flex"
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
                                            width: 15,
                                            height: 15,
                                            viewBox: "0 0 52.974 52.974",
                                            fill: palette/* sealBlue */.N9,
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                                    d: "M49.467 3.51c-4.677-4.679-12.291-4.681-16.97 0l-9.192 9.192a.999.999 0 1 0 1.414 1.414l9.192-9.192a9.927 9.927 0 0 1 7.07-2.915c2.681 0 5.191 1.036 7.071 2.916s2.916 4.391 2.916 7.071c0 2.68-1.036 5.19-2.916 7.07L36.033 31.088c-3.898 3.898-10.244 3.898-14.143 0a.999.999 0 1 0-1.414 1.414c2.34 2.339 5.412 3.509 8.485 3.509s6.146-1.17 8.485-3.509L49.467 20.48a11.914 11.914 0 0 0 3.502-8.485c0-3.214-1.244-6.227-3.502-8.485z"
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                                    d: "M26.84 40.279l-7.778 7.778a9.928 9.928 0 0 1-7.071 2.916 9.93 9.93 0 0 1-7.071-2.916c-3.898-3.898-3.898-10.243 0-14.142l11.314-11.314c3.899-3.898 10.244-3.896 14.142 0a.999.999 0 1 0 1.414-1.414c-4.677-4.679-12.291-4.681-16.97 0L3.505 32.502a11.914 11.914 0 0 0-3.501 8.485c0 3.214 1.244 6.227 3.502 8.484s5.271 3.502 8.484 3.502c3.215 0 6.228-1.244 8.485-3.502l7.778-7.778a.999.999 0 1 0-1.413-1.414z"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Input */.II, {
                                        innerRef: inputRef,
                                        onChange: function() {},
                                        value: SharingBox_getSharingUrl(government.slug),
                                        onFocus: function(e) {
                                            return e.target.select();
                                        },
                                        css: {
                                            paddingLeft: 40,
                                            borderColor: palette/* lightSealBlue */.oz,
                                            borderStyle: "dashed"
                                        }
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: {
                        display: "flex",
                        alignItems: "center",
                        padding: 16,
                        justifyContent: "flex-end",
                        borderTop: "1px solid ".concat(palette/* lightestGray */.v2)
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(core/* AnchorButton */.AN, {
                            href: SharingBox_getSharingUrl(government.slug),
                            target: "_blank",
                            rel: "noopener noreferrer",
                            size: "xsmall",
                            color: palette/* innovatorBlue */.LD,
                            css: {
                                display: "inline-flex",
                                marginRight: 8
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                    css: {
                                        marginRight: 10,
                                        display: "inline-flex"
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
                                        width: 15,
                                        height: 15,
                                        viewBox: "0 0 511.626 511.627",
                                        fill: "#fff",
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                                d: "M392.857 292.354h-18.274c-2.669 0-4.859.855-6.563 2.573-1.718 1.708-2.573 3.897-2.573 6.563v91.361c0 12.563-4.47 23.315-13.415 32.262-8.945 8.945-19.701 13.414-32.264 13.414H82.224c-12.562 0-23.317-4.469-32.264-13.414-8.945-8.946-13.417-19.698-13.417-32.262V155.31c0-12.562 4.471-23.313 13.417-32.259 8.947-8.947 19.702-13.418 32.264-13.418h200.994c2.669 0 4.859-.859 6.57-2.57 1.711-1.713 2.566-3.9 2.566-6.567V82.221c0-2.662-.855-4.853-2.566-6.563-1.711-1.713-3.901-2.568-6.57-2.568H82.224c-22.648 0-42.016 8.042-58.102 24.125C8.042 113.297 0 132.665 0 155.313v237.542c0 22.647 8.042 42.018 24.123 58.095 16.086 16.084 35.454 24.13 58.102 24.13h237.543c22.647 0 42.017-8.046 58.101-24.13 16.085-16.077 24.127-35.447 24.127-58.095v-91.358c0-2.669-.856-4.859-2.574-6.57-1.713-1.718-3.903-2.573-6.565-2.573z"
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                                d: "M506.199 41.971c-3.617-3.617-7.905-5.424-12.85-5.424H347.171c-4.948 0-9.233 1.807-12.847 5.424-3.617 3.615-5.428 7.898-5.428 12.847s1.811 9.233 5.428 12.85l50.247 50.248-186.147 186.151c-1.906 1.903-2.856 4.093-2.856 6.563 0 2.479.953 4.668 2.856 6.571l32.548 32.544c1.903 1.903 4.093 2.852 6.567 2.852s4.665-.948 6.567-2.852l186.148-186.148 50.251 50.248c3.614 3.617 7.898 5.426 12.847 5.426s9.233-1.809 12.851-5.426c3.617-3.616 5.424-7.898 5.424-12.847V54.818c-.001-4.952-1.814-9.232-5.428-12.847z"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "Open",
                                        id: "JfG49w"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: {
                                display: "flex",
                                alignItems: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(core/* Button */.zx, {
                                    theme: "secondary",
                                    size: "xsmall",
                                    onClick: setClipboard,
                                    color: palette/* innovatorBlue */.LD,
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                            css: {
                                                marginRight: 10,
                                                display: "inline-flex"
                                            },
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
                                                width: 15,
                                                height: 15,
                                                viewBox: "0 0 488.3 488.3",
                                                fill: palette/* primary */.T$,
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                                        d: "M314.25 85.4h-227c-21.3 0-38.6 17.3-38.6 38.6v325.7c0 21.3 17.3 38.6 38.6 38.6h227c21.3 0 38.6-17.3 38.6-38.6V124c-.1-21.3-17.4-38.6-38.6-38.6zm11.5 364.2c0 6.4-5.2 11.6-11.6 11.6h-227c-6.4 0-11.6-5.2-11.6-11.6V124c0-6.4 5.2-11.6 11.6-11.6h227c6.4 0 11.6 5.2 11.6 11.6v325.6z"
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                                        d: "M401.05 0h-227c-21.3 0-38.6 17.3-38.6 38.6 0 7.5 6 13.5 13.5 13.5s13.5-6 13.5-13.5c0-6.4 5.2-11.6 11.6-11.6h227c6.4 0 11.6 5.2 11.6 11.6v325.7c0 6.4-5.2 11.6-11.6 11.6-7.5 0-13.5 6-13.5 13.5s6 13.5 13.5 13.5c21.3 0 38.6-17.3 38.6-38.6V38.6c0-21.3-17.3-38.6-38.6-38.6z"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                defaultMessage: "Copy",
                                                id: "4l6vz1"
                                            })
                                        })
                                    ]
                                }),
                                copied && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                    css: {
                                        marginLeft: 6,
                                        color: palette/* greenSuccess */.CU
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Copied",
                                            id: "p556q3"
                                        }),
                                        "!"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyBlocks/* NoSharingPage */.pH, {
        "data-intercom-target": "Government Sharing",
        onStartSharing: function() {
            router.push("/governments/[governmentSlug]/[[...content]]", "/governments/".concat(government.slug, "/sharing"));
        }
    });
};
function SharingBox_getSharingUrl(slug) {
    if (true) {
        return "https://".concat(slug, ".govlaunch.com");
    }
    if (false) {}
    return "http://localhost:3004?government=".concat(slug);
}
/* harmony default export */ var government_SharingBox = (SharingBox);

// EXTERNAL MODULE: ./components/profile/NewLinkTab.tsx
var NewLinkTab = __webpack_require__(37897);
// EXTERNAL MODULE: ./components/group/NoResultsFound.tsx
var NoResultsFound = __webpack_require__(15545);
// EXTERNAL MODULE: ./components/mediaQueries.ts
var mediaQueries = __webpack_require__(92418);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+algolia@1.5.0_ggl46zudxxlqvmbfh2i2q4ymge/node_modules/@govlaunch/algolia/index.js + 3 modules
var algolia = __webpack_require__(96429);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+select@0.33.1_3s36zatsal5pm5ktsv6lgzncae/node_modules/@govlaunch/select/index.js + 44 modules
var _govlaunch_select = __webpack_require__(3104);
// EXTERNAL MODULE: ./node_modules/.pnpm/final-form@4.20.7/node_modules/final-form/dist/final-form.es.js
var final_form_es = __webpack_require__(60681);
;// CONCATENATED MODULE: ./lib/mutations/SetGovernmentProductStack.ts

function SetGovernmentProductStack_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation SetGovernmentProductStack($products: [ObjectId], $outsideProducts: [OutsideProductInput]) {\n    setGovernmentProductStack(productIds: $products, outsideProducts: $outsideProducts) {\n      _id\n      productsCount\n      products {\n        _id\n        name\n        slug\n        description\n        logo\n        isDisruptor\n        inViewerStack\n        company {\n          _id\n          name\n          slug\n        }\n      }\n      outsideProducts {\n        _id\n        name\n        url\n      }\n    }\n  }\n"
    ]);
    SetGovernmentProductStack_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var SetGovernmentProductStack = ((0,lib/* gql */.Ps)(SetGovernmentProductStack_templateObject()));

;// CONCATENATED MODULE: ./components/government/AddProductsToStack.tsx

















var AddProductsToStack = function(param) {
    var government = param.government, productsInStack = param.productsInStack, isOpen = param.isOpen, toggleOpen = param.toggleOpen;
    var intl = (0,useIntl/* default */.Z)();
    var user = (0,Auth/* useSelfie */.yD)();
    var maxProductSuggestions = intl.formatMessage({
        id: "Hbm59/",
        defaultMessage: "You've reached the limit of 50 product suggestions per day",
        description: "Error message for when a user reaches the limit of product suggestions"
    });
    var couldNotUpdate = intl.formatMessage({
        defaultMessage: "Could not update government stack",
        id: "yK+c09"
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Modal */.u_, {
        isOpen: isOpen,
        onRequestClose: toggleOpen,
        ariaHideApp: false,
        overlayStyle: {
            zIndex: 1000
        },
        style: {
            overflow: "visible"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(core/* Box */.xu, {
            p: 15,
            width: [
                340,
                560,
                560,
                768
            ],
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Mobile */.ij, {
                    children: function(isMobile) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: {
                                display: "flex",
                                alignItems: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                    css: {
                                        display: "flex",
                                        alignItems: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(profile_picture/* default */.Z, {
                                            size: isMobile ? 32 : 42,
                                            image: government.logo,
                                            name: government.name,
                                            innovator: government.isInnovator
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                            ml: 10,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h3", {
                                                css: {
                                                    fontSize: isMobile ? 16 : 23,
                                                    margin: 0,
                                                    color: palette/* darkGray */.O5
                                                },
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                    defaultMessage: "Edit {cityName} Product Stack",
                                                    id: "FSpeWm",
                                                    values: {
                                                        cityName: government.city.name
                                                    }
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                    onClick: toggleOpen,
                                    role: "button",
                                    "aria-label": "Close",
                                    css: {
                                        marginLeft: "auto",
                                        alignSelf: isMobile ? "auto" : "flex-start",
                                        color: palette/* sealBlue */.N9,
                                        fontWeight: 500,
                                        display: "flex",
                                        alignItems: "center",
                                        cursor: "pointer",
                                        "&:hover": {
                                            color: palette/* mediumGray */.rF
                                        }
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                            css: {
                                                fontSize: 22
                                            },
                                            children: "\xd7"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                            ml: 2.5,
                                            css: {
                                                display: "inline-flex"
                                            },
                                            children: !isMobile && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                css: {
                                                    fontSize: 12,
                                                    textTransform: "uppercase"
                                                },
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                    defaultMessage: "Close",
                                                    id: "rbrahO"
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        });
                    }
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                    mt: 20,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
                        mutation: SetGovernmentProductStack,
                        children: function(setGovernmentProductStack) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Form */.l0, {
                                onSubmit: function() {
                                    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
                                        var products, outsideProducts, govlaunchProducts;
                                        return runtime_default().wrap(function _callee$(_ctx) {
                                            while(1)switch(_ctx.prev = _ctx.next){
                                                case 0:
                                                    products = param.products;
                                                    outsideProducts = products.filter(function(product) {
                                                        return product.id;
                                                    });
                                                    govlaunchProducts = products.filter(function(product) {
                                                        return product._id;
                                                    });
                                                    _ctx.prev = 3;
                                                    _ctx.next = 6;
                                                    return setGovernmentProductStack({
                                                        variables: {
                                                            products: govlaunchProducts.map(function(product) {
                                                                return product._id;
                                                            }),
                                                            outsideProducts: outsideProducts.map(function(outsideProduct) {
                                                                return {
                                                                    name: outsideProduct.name,
                                                                    url: outsideProduct.url
                                                                };
                                                            })
                                                        }
                                                    }).then(toggleOpen);
                                                case 6:
                                                    return _ctx.abrupt("return", null);
                                                case 9:
                                                    _ctx.prev = 9;
                                                    _ctx.t0 = _ctx["catch"](3);
                                                    if (!/maximum number of product suggestions/i.test(_ctx.t0.message)) {
                                                        _ctx.next = 13;
                                                        break;
                                                    }
                                                    return _ctx.abrupt("return", (0,_define_property/* default */.Z)({}, final_form_es/* FORM_ERROR */.Ck, maxProductSuggestions));
                                                case 13:
                                                    return _ctx.abrupt("return", (0,_define_property/* default */.Z)({}, final_form_es/* FORM_ERROR */.Ck, couldNotUpdate));
                                                case 14:
                                                case "end":
                                                    return _ctx.stop();
                                            }
                                        }, _callee, null, [
                                            [
                                                3,
                                                9
                                            ]
                                        ]);
                                    }));
                                    return function(_) {
                                        return _ref.apply(this, arguments);
                                    };
                                }(),
                                initialValues: {
                                    products: productsInStack
                                },
                                children: function(param) {
                                    var handleSubmit = param.handleSubmit, submitError = param.submitError;
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("form", {
                                        onSubmit: handleSubmit,
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
                                                name: "products",
                                                children: function(param) {
                                                    var input = param.input;
                                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(algolia/* SearchAlgoliaIndex */.d, {
                                                        index: "products",
                                                        params: {
                                                            restrictSearchableAttributes: [
                                                                "name"
                                                            ]
                                                        },
                                                        user: user,
                                                        children: function(param) {
                                                            var products = param.results, inputValue = param.searchValue, onInputValueChange = param.onChange;
                                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_govlaunch_select/* StoryProductSelect */.Ts, {
                                                                products: input.value,
                                                                placeholder: intl.formatMessage({
                                                                    defaultMessage: "What are the products you want to add?",
                                                                    id: "cbABH5"
                                                                }),
                                                                inputValue: inputValue,
                                                                onInputValueChange: onInputValueChange,
                                                                selectableProducts: products,
                                                                onChange: input.onChange,
                                                                css: {
                                                                    minWidth: 300
                                                                }
                                                            });
                                                        }
                                                    });
                                                }
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(spacings/* Margin */.Zt, {
                                                mt: 20,
                                                style: {
                                                    display: "flex",
                                                    alignItems: "center"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                                                        type: "submit",
                                                        flex: 0.7,
                                                        theme: "primary",
                                                        color: "success",
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                            defaultMessage: "Save Changes",
                                                            id: "3VI9mt"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                                        ml: 10,
                                                        style: {
                                                            flex: 0.3
                                                        },
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                                                            type: "button",
                                                            width: "100%",
                                                            theme: "secondary",
                                                            color: "success",
                                                            onClick: toggleOpen,
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                                defaultMessage: "Cancel",
                                                                id: "47FYwb"
                                                            })
                                                        })
                                                    })
                                                ]
                                            }),
                                            submitError && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                                mt: 8,
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                    css: {
                                                        color: palette/* red */.Q6,
                                                        fontSize: 14
                                                    },
                                                    children: submitError
                                                })
                                            })
                                        ]
                                    });
                                }
                            });
                        }
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var government_AddProductsToStack = (AddProductsToStack);

// EXTERNAL MODULE: ./lib/utils/apostrophe.ts
var apostrophe = __webpack_require__(93430);
;// CONCATENATED MODULE: ./components/government/NoDataBoxes.tsx








var NoProductsInStack = function(param) {
    var government = param.government, onAddProduct = param.onAddProduct;
    if (!government.viewerIsMember) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: {
                backgroundColor: palette/* white */.ix,
                borderRadius: 5,
                border: "solid 1px ".concat(palette/* lightestGray */.v2)
            },
            "data-intercom-target": "Government Stack",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    css: {
                        padding: 15,
                        borderBottom: "solid 1px ".concat(palette/* lightestGray */.v2),
                        display: "flex",
                        justifyContent: "space-between"
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                        css: {
                            textTransform: "uppercase",
                            fontSize: 12,
                            color: palette/* sealBlue */.N9,
                            letterSpacing: 0.5,
                            fontWeight: 500
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "{cityName} Stack ({productsCount})",
                            id: "dxKKRK",
                            values: {
                                cityName: (0,apostrophe/* default */.Z)(government.city.name),
                                productsCount: (government.products || []).length
                            }
                        })
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: {
                        padding: 20,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectingIllustration, {
                            width: 72,
                            height: 75
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: {
                                textAlign: "left",
                                marginLeft: 20
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                    css: {
                                        fontSize: 21,
                                        margin: 0,
                                        color: palette/* darkGray */.O5,
                                        fontWeight: "bold"
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "{cityName} has not added any products to their Stack",
                                        id: "4bE2qZ",
                                        values: {
                                            cityName: government.city.name
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                    css: {
                                        fontSize: 14,
                                        margin: 0,
                                        marginTop: 2.5,
                                        fontWeight: 400,
                                        color: palette/* mediumGray */.rF
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "Stack is a collection of products the government is currently using.",
                                        id: "6yi5le"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyBlocks/* NoProducts */.ss, {
        "data-intercom-target": "Government Stack",
        onAddProduct: onAddProduct
    });
};
var CollectingIllustration = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 104,
        height: 108.5,
        viewBox: "0 0 208 217"
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("defs", {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "prefix__a",
                        x1: "0%",
                        y1: "50.001%",
                        y2: "50.001%",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0%",
                                stopColor: "gray",
                                stopOpacity: 0.25
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "54%",
                                stopColor: "gray",
                                stopOpacity: 0.12
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "100%",
                                stopColor: "gray",
                                stopOpacity: 0.1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "prefix__b",
                        x1: "0%",
                        y1: "50%",
                        y2: "50%",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0%",
                                stopColor: "gray",
                                stopOpacity: 0.25
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "54%",
                                stopColor: "gray",
                                stopOpacity: 0.12
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "100%",
                                stopColor: "gray",
                                stopOpacity: 0.1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "prefix__c",
                        x1: "50%",
                        x2: "50%",
                        y1: "99.994%",
                        y2: "0%",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0%",
                                stopColor: "gray",
                                stopOpacity: 0.25
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "54%",
                                stopColor: "gray",
                                stopOpacity: 0.12
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "100%",
                                stopColor: "gray",
                                stopOpacity: 0.1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "prefix__d",
                        x1: "0%",
                        y1: "49.981%",
                        y2: "49.981%",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0%",
                                stopColor: "gray",
                                stopOpacity: 0.25
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "54%",
                                stopColor: "gray",
                                stopOpacity: 0.12
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "100%",
                                stopColor: "gray",
                                stopOpacity: 0.1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "prefix__e",
                        x1: "50%",
                        x2: "50%",
                        y1: "100%",
                        y2: "0%",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0%",
                                stopColor: "gray",
                                stopOpacity: 0.25
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "54%",
                                stopColor: "gray",
                                stopOpacity: 0.12
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "100%",
                                stopColor: "gray",
                                stopOpacity: 0.1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "prefix__f",
                        x1: "0%",
                        x2: "100.006%",
                        y1: "50%",
                        y2: "50%",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0%",
                                stopColor: "gray",
                                stopOpacity: 0.25
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "54%",
                                stopColor: "gray",
                                stopOpacity: 0.12
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "100%",
                                stopColor: "gray",
                                stopOpacity: 0.1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "prefix__g",
                        x1: "0%",
                        y1: "49.997%",
                        y2: "49.997%",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0%",
                                stopColor: "gray",
                                stopOpacity: 0.25
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "54%",
                                stopColor: "gray",
                                stopOpacity: 0.12
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "100%",
                                stopColor: "gray",
                                stopOpacity: 0.1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "prefix__h",
                        x1: "0%",
                        x2: "100.031%",
                        y1: "50%",
                        y2: "50%",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0%",
                                stopColor: "gray",
                                stopOpacity: 0.25
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "54%",
                                stopColor: "gray",
                                stopOpacity: 0.12
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "100%",
                                stopColor: "gray",
                                stopOpacity: 0.1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "prefix__i",
                        x1: "0%",
                        y1: "49.996%",
                        y2: "49.996%",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0%",
                                stopColor: "gray",
                                stopOpacity: 0.25
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "54%",
                                stopColor: "gray",
                                stopOpacity: 0.12
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "100%",
                                stopColor: "gray",
                                stopOpacity: 0.1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "prefix__j",
                        x1: "50.007%",
                        x2: "50.007%",
                        y1: "100%",
                        y2: "0%",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0%",
                                stopColor: "gray",
                                stopOpacity: 0.25
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "54%",
                                stopColor: "gray",
                                stopOpacity: 0.12
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "100%",
                                stopColor: "gray",
                                stopOpacity: 0.1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "prefix__k",
                        x1: "0%",
                        y1: "50.008%",
                        y2: "50.008%",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0%",
                                stopColor: "gray",
                                stopOpacity: 0.25
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "54%",
                                stopColor: "gray",
                                stopOpacity: 0.12
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "100%",
                                stopColor: "gray",
                                stopOpacity: 0.1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "prefix__l",
                        x1: "50.017%",
                        x2: "50.017%",
                        y1: "99.899%",
                        y2: "-.151%",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0%",
                                stopColor: "gray",
                                stopOpacity: 0.25
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "54%",
                                stopColor: "gray",
                                stopOpacity: 0.12
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "100%",
                                stopColor: "gray",
                                stopOpacity: 0.1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "prefix__m",
                        x1: "0%",
                        x2: "100.037%",
                        y1: "50%",
                        y2: "50%",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0%",
                                stopColor: "gray",
                                stopOpacity: 0.25
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "54%",
                                stopColor: "gray",
                                stopOpacity: 0.12
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "100%",
                                stopColor: "gray",
                                stopOpacity: 0.1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "prefix__n",
                        x1: ".089%",
                        y1: "50.127%",
                        y2: "50.127%",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0%",
                                stopColor: "gray",
                                stopOpacity: 0.25
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "54%",
                                stopColor: "gray",
                                stopOpacity: 0.12
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "100%",
                                stopColor: "gray",
                                stopOpacity: 0.1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "prefix__o",
                        x1: "0%",
                        x2: "100.04%",
                        y1: "50%",
                        y2: "50%",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0%",
                                stopColor: "gray",
                                stopOpacity: 0.25
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "54%",
                                stopColor: "gray",
                                stopOpacity: 0.12
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "100%",
                                stopColor: "gray",
                                stopOpacity: 0.1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "prefix__p",
                        x1: "50.011%",
                        x2: "50.011%",
                        y1: "100%",
                        y2: "0%",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0%",
                                stopColor: "gray",
                                stopOpacity: 0.25
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "54%",
                                stopColor: "gray",
                                stopOpacity: 0.12
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "100%",
                                stopColor: "gray",
                                stopOpacity: 0.1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "prefix__q",
                        x1: "0%",
                        y1: "49.969%",
                        y2: "49.969%",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0%",
                                stopColor: "gray",
                                stopOpacity: 0.25
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "54%",
                                stopColor: "gray",
                                stopOpacity: 0.12
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "100%",
                                stopColor: "gray",
                                stopOpacity: 0.1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "prefix__r",
                        x1: "0%",
                        x2: "99.987%",
                        y1: "50%",
                        y2: "50%",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0%",
                                stopColor: "gray",
                                stopOpacity: 0.25
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "54%",
                                stopColor: "gray",
                                stopOpacity: 0.12
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "100%",
                                stopColor: "gray",
                                stopOpacity: 0.1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "prefix__s",
                        x1: "0%",
                        x2: "99.982%",
                        y1: "49.845%",
                        y2: "49.845%",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0%",
                                stopColor: "gray",
                                stopOpacity: 0.25
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "54%",
                                stopColor: "gray",
                                stopOpacity: 0.12
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "100%",
                                stopColor: "gray",
                                stopOpacity: 0.1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "prefix__t",
                        x1: "0%",
                        y1: "49.845%",
                        y2: "49.845%",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0%",
                                stopColor: "gray",
                                stopOpacity: 0.25
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "54%",
                                stopColor: "gray",
                                stopOpacity: 0.12
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "100%",
                                stopColor: "gray",
                                stopOpacity: 0.1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "prefix__u",
                        x1: "0%",
                        x2: "99.982%",
                        y1: "50.155%",
                        y2: "50.155%",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0%",
                                stopColor: "gray",
                                stopOpacity: 0.25
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "54%",
                                stopColor: "gray",
                                stopOpacity: 0.12
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "100%",
                                stopColor: "gray",
                                stopOpacity: 0.1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "prefix__v",
                        x1: "0%",
                        y1: "50.155%",
                        y2: "50.155%",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0%",
                                stopColor: "gray",
                                stopOpacity: 0.25
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "54%",
                                stopColor: "gray",
                                stopOpacity: 0.12
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "100%",
                                stopColor: "gray",
                                stopOpacity: 0.1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "prefix__w",
                        x1: "0%",
                        x2: "99.991%",
                        y1: "49.994%",
                        y2: "49.994%",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0%",
                                stopColor: "gray",
                                stopOpacity: 0.25
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "54%",
                                stopColor: "gray",
                                stopOpacity: 0.12
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "100%",
                                stopColor: "gray",
                                stopOpacity: 0.1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "prefix__x",
                        x1: "0%",
                        x2: "99.991%",
                        y1: "50%",
                        y2: "50%",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0%",
                                stopColor: "gray",
                                stopOpacity: 0.25
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "54%",
                                stopColor: "gray",
                                stopOpacity: 0.12
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "100%",
                                stopColor: "gray",
                                stopOpacity: 0.1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "prefix__y",
                        x1: "0%",
                        y1: "49.875%",
                        y2: "49.875%",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0%",
                                stopColor: "gray",
                                stopOpacity: 0.25
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "54%",
                                stopColor: "gray",
                                stopOpacity: 0.12
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "100%",
                                stopColor: "gray",
                                stopOpacity: 0.1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "prefix__z",
                        x1: "0%",
                        y1: "50.125%",
                        y2: "50.125%",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0%",
                                stopColor: "gray",
                                stopOpacity: 0.25
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "54%",
                                stopColor: "gray",
                                stopOpacity: 0.12
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "100%",
                                stopColor: "gray",
                                stopOpacity: 0.1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "prefix__A",
                        x1: "50.006%",
                        x2: "50.006%",
                        y1: "100%",
                        y2: "0%",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0%",
                                stopColor: "gray",
                                stopOpacity: 0.25
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "54%",
                                stopColor: "gray",
                                stopOpacity: 0.12
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "100%",
                                stopColor: "gray",
                                stopOpacity: 0.1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "prefix__B",
                        x1: "50.003%",
                        x2: "50.003%",
                        y1: "100%",
                        y2: "0%",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0%",
                                stopColor: "gray",
                                stopOpacity: 0.25
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "54%",
                                stopColor: "gray",
                                stopOpacity: 0.12
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "100%",
                                stopColor: "gray",
                                stopOpacity: 0.1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "prefix__C",
                        x1: "50.013%",
                        x2: "50.013%",
                        y1: "100%",
                        y2: "0%",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0%",
                                stopColor: "gray",
                                stopOpacity: 0.25
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "54%",
                                stopColor: "gray",
                                stopOpacity: 0.12
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "100%",
                                stopColor: "gray",
                                stopOpacity: 0.1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "prefix__D",
                        x1: "49.983%",
                        x2: "49.983%",
                        y1: "100.203%",
                        y2: ".254%",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0%",
                                stopColor: "gray",
                                stopOpacity: 0.25
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "54%",
                                stopColor: "gray",
                                stopOpacity: 0.12
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "100%",
                                stopColor: "gray",
                                stopOpacity: 0.1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "prefix__E",
                        x1: "49.983%",
                        x2: "49.983%",
                        y1: "100%",
                        y2: "0%",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0%",
                                stopColor: "gray",
                                stopOpacity: 0.25
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "54%",
                                stopColor: "gray",
                                stopOpacity: 0.12
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "100%",
                                stopColor: "gray",
                                stopOpacity: 0.1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "prefix__F",
                        x1: "50.005%",
                        x2: "50.005%",
                        y1: "100%",
                        y2: "0%",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0%",
                                stopColor: "gray",
                                stopOpacity: 0.25
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "54%",
                                stopColor: "gray",
                                stopOpacity: 0.12
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "100%",
                                stopColor: "gray",
                                stopOpacity: 0.1
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                fill: "none",
                fillRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                        opacity: 0.7,
                        transform: "translate(0 36)",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "url(#prefix__a)",
                                d: "M171.998 67.553l-68.44-16.52V180.33l68.44-17.956z"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "url(#prefix__a)",
                                d: "M68.545 16.557L.105.037v129.296l68.44-17.957z",
                                opacity: 0.1,
                                transform: "translate(103.453 50.996)"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "url(#prefix__a)",
                                d: "M35.115 67.553l68.443-16.52V180.33l-68.443-17.6z"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "url(#prefix__a)",
                                d: "M.065 16.557L68.508.037v129.296l-68.443-17.6z",
                                opacity: 0.17,
                                transform: "translate(35.05 50.996)"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "url(#prefix__b)",
                                d: "M103.558 51.033l35.474-29.45 68.44 17.6-35.474 28.37zM0 39.54l35.115 28.013 68.443-16.52-34.759-29.45z"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "url(#prefix__b)",
                                d: "M0 18.007l35.115 28.014 68.443-16.52L68.799.051z",
                                opacity: 0.05,
                                transform: "translate(0 21.532)"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                                width: 50.8,
                                height: 46.979,
                                x: 0.22,
                                y: 0.108,
                                fill: "url(#prefix__c)",
                                opacity: 0.5,
                                rx: 4.5,
                                transform: "translate(52.575 35.98)"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                                width: 49.629,
                                height: 45.84,
                                x: 53.414,
                                y: 36.451,
                                fill: "url(#prefix__b)",
                                rx: 4.5
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                                width: 8.37,
                                height: 7.55,
                                x: 57.239,
                                y: 44.001,
                                fill: "url(#prefix__d)",
                                rx: 3.775
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                                width: 33.272,
                                height: 1,
                                x: 68.118,
                                y: 44.001,
                                fill: "url(#prefix__b)",
                                rx: 0.5
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                                width: 33.272,
                                height: 1,
                                x: 68.118,
                                y: 46.517,
                                fill: "url(#prefix__b)",
                                rx: 0.5
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                                width: 44.988,
                                height: 1,
                                x: 56.402,
                                y: 55.654,
                                fill: "url(#prefix__b)",
                                rx: 0.5
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                                width: 44.988,
                                height: 1,
                                x: 56.402,
                                y: 58.17,
                                fill: "url(#prefix__b)",
                                rx: 0.5
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                                width: 44.988,
                                height: 1,
                                x: 56.402,
                                y: 61.524,
                                fill: "url(#prefix__b)",
                                rx: 0.5
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                                width: 25.945,
                                height: 1,
                                x: 56.402,
                                y: 64.043,
                                fill: "url(#prefix__b)",
                                rx: 0.5
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                                width: 44.988,
                                height: 1,
                                x: 56.402,
                                y: 67.389,
                                fill: "url(#prefix__b)",
                                rx: 0.5
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                                width: 44.988,
                                height: 1,
                                x: 56.402,
                                y: 69.905,
                                fill: "url(#prefix__b)",
                                rx: 0.5
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                                width: 44.988,
                                height: 1,
                                x: 56.402,
                                y: 73.262,
                                fill: "url(#prefix__b)",
                                rx: 0.5
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                                width: 25.945,
                                height: 1,
                                x: 56.402,
                                y: 75.778,
                                fill: "url(#prefix__b)",
                                rx: 0.5
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                                width: 50.8,
                                height: 46.979,
                                x: 0.254,
                                y: 0.195,
                                fill: "url(#prefix__e)",
                                opacity: 0.5,
                                rx: 4.5,
                                transform: "translate(60.206 46.747)"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                                width: 49.629,
                                height: 45.84,
                                x: 61.08,
                                y: 47.308,
                                fill: "url(#prefix__b)",
                                rx: 4.5
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                                width: 8.37,
                                height: 7.55,
                                x: 64.904,
                                y: 54.858,
                                fill: "url(#prefix__d)",
                                rx: 3.775
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                                width: 33.272,
                                height: 1,
                                x: 75.787,
                                y: 54.858,
                                fill: "url(#prefix__b)",
                                rx: 0.5
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                                width: 33.272,
                                height: 1,
                                x: 75.787,
                                y: 57.374,
                                fill: "url(#prefix__b)",
                                rx: 0.5
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                                width: 44.988,
                                height: 1,
                                x: 64.068,
                                y: 66.508,
                                fill: "url(#prefix__f)",
                                rx: 0.5
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                                width: 44.988,
                                height: 1,
                                x: 64.068,
                                y: 69.027,
                                fill: "url(#prefix__f)",
                                rx: 0.5
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                                width: 44.988,
                                height: 1,
                                x: 64.068,
                                y: 72.381,
                                fill: "url(#prefix__f)",
                                rx: 0.5
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                                width: 25.945,
                                height: 1,
                                x: 64.068,
                                y: 74.897,
                                fill: "url(#prefix__b)",
                                rx: 0.5
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                                width: 44.988,
                                height: 1,
                                x: 64.068,
                                y: 78.246,
                                fill: "url(#prefix__f)",
                                rx: 0.5
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                                width: 44.988,
                                height: 1,
                                x: 64.068,
                                y: 80.761,
                                fill: "url(#prefix__f)",
                                rx: 0.5
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                                width: 44.988,
                                height: 1,
                                x: 64.068,
                                y: 84.119,
                                fill: "url(#prefix__f)",
                                rx: 0.5
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                                width: 25.945,
                                height: 1,
                                x: 64.068,
                                y: 86.634,
                                fill: "url(#prefix__b)",
                                rx: 0.5
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "url(#prefix__e)",
                                d: "M.116.042h44.016v51.835H.116z",
                                opacity: 0.5,
                                transform: "translate(89.886 52.98)"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "url(#prefix__g)",
                                d: "M91.356 53.858h41.726v49.855H91.356z"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "url(#prefix__e)",
                                fillRule: "nonzero",
                                d: "M7.929 1.44V.186H3.392v1.252H.2V7.59h10.91V1.44H7.93zM3.957.636H7.35v.797H3.957V.637z",
                                opacity: 0.5,
                                transform: "translate(106.563 60.346)"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "url(#prefix__b)",
                                d: "M107.224 61.992h9.989v5.632h-9.989z"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "url(#prefix__b)",
                                d: "M110.138 60.844v1.462h.52v-1.042h3.12v1.042h.521v-1.462zM97.6 75.73h29.343v1.252H97.6zm0 8.238h29.343v1.252H97.6zm0 2.19h29.343v1.252H97.6zm0-4.38h12.383v1.252H97.6z"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "url(#prefix__b)",
                                d: "M.096.184h9.26v1.252H.096z",
                                opacity: 0.6,
                                transform: "translate(117.586 81.594)"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "url(#prefix__h)",
                                d: "M107.9 91.269h9.26v1.252h-9.26z"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "url(#prefix__b)",
                                d: "M35.115 67.553v95.177l68.443 17.6V85.871zm136.883 94.82l-68.44 17.956V85.872l68.44-18.319z"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "url(#prefix__b)",
                                d: "M68.545 94.944L.105 112.9V18.444L68.545.124z",
                                opacity: 0.07,
                                transform: "translate(103.453 67.429)"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "url(#prefix__i)",
                                d: "M.042 7.808v31.247l27.235-7.542V.266z",
                                opacity: 0.07,
                                transform: "translate(144.722 122.958)"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "url(#prefix__j)",
                                d: "M136.18 59.615h20.185v19.438H136.18z"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "url(#prefix__k)",
                                d: "M136.496 60.091h19.552v18.566h-19.552z"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "url(#prefix__l)",
                                fillRule: "nonzero",
                                d: "M6.105 1.017V.071H2.65v.952H.226v4.68h8.302V1.017H6.105zM3.081.411h2.595v.606H3.08V.411z",
                                opacity: 0.5,
                                transform: "translate(141.895 62.329)"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "url(#prefix__m)",
                                d: "M.011.042h7.598v4.284H.011z",
                                opacity: 0.6,
                                transform: "translate(142.46 63.462)"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "url(#prefix__n)",
                                d: "M.249.017V1.13h.398V.337h2.375v.793h.395V.017z",
                                opacity: 0.6,
                                transform: "translate(144.439 62.612)"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "url(#prefix__o)",
                                d: "M.164.008h7.044v1H.164z",
                                opacity: 0.6,
                                transform: "translate(142.743 71.112)"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "url(#prefix__b)",
                                d: "M140.256 72.865h12.033v1h-12.033z"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "url(#prefix__p)",
                                d: "M.139.195h26.152v21.532H.139z",
                                opacity: 0.5,
                                transform: "translate(88.19)"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "url(#prefix__b)",
                                d: "M88.634.603h25.493V21.37H88.634z"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "url(#prefix__q)",
                                d: "M88.634.603h25.493v4.632H88.634z"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "url(#prefix__q)",
                                d: "M.161.037h25.493v4.632H.161z",
                                opacity: 0.1,
                                transform: "translate(88.472 .567)"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "url(#prefix__r)",
                                d: "M90.666 6.916h21.431v2.697H90.666z"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "url(#prefix__s)",
                                d: "M90.666 11.65h15.642v1H90.666z"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "url(#prefix__t)",
                                d: "M90.666 13.228h10.156v1H90.666zm0 1.578h13.407v1H90.666z"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "url(#prefix__u)",
                                d: "M90.666 16.381h15.642v1H90.666z"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "url(#prefix__v)",
                                d: "M90.666 17.959h5.229v1h-5.229z"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "url(#prefix__e)",
                                d: "M.147.215h32.415V26.9H.147z",
                                opacity: 0.5,
                                transform: "translate(126.631 16.149)"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "url(#prefix__w)",
                                d: "M127.157 16.868h31.599v25.739h-31.599z"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "url(#prefix__x)",
                                d: "M127.157 16.868h31.599v5.74h-31.599z"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "url(#prefix__b)",
                                d: "M129.673 24.691h26.562v3.343h-26.562z"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "url(#prefix__y)",
                                d: "M129.673 30.558h19.388v1.136h-19.388z"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "url(#prefix__z)",
                                d: "M129.673 32.513h12.59v1.136h-12.59z"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "url(#prefix__y)",
                                d: "M129.673 34.471h16.618v1.136h-16.618zm0 1.955h19.388v1.136h-19.388z"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "url(#prefix__z)",
                                d: "M129.673 38.38h6.484v1.136h-6.484z"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "url(#prefix__b)",
                                d: "M131.058 25.827h7.553v1.009h-7.553z"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "url(#prefix__b)",
                                d: "M.02 48.376l38.34 9.698 30.815-25.142V17.49L.735.249z",
                                opacity: 0.1,
                                transform: "translate(34.202 68.562)"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "url(#prefix__b)",
                                d: "M69.365 48.376l-38.343 9.698L.206 32.932V17.49L68.646.249z",
                                opacity: 0.1,
                                transform: "translate(103.17 68.562)"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "url(#prefix__b)",
                                d: "M35.115 67.553L0 96.647l68.44 17.24 35.118-28.015z"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "url(#prefix__b)",
                                d: "M171.998 67.553l35.474 29.094-68.081 17.24-35.833-28.015z"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "url(#prefix__b)",
                                d: "M68.545.125l35.474 29.093-68.082 17.24L.105 18.444z",
                                opacity: 0.07,
                                transform: "translate(103.453 67.429)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#535461",
                        d: "M172 103.357L104 87v128l68-17.777z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#000",
                        d: "M172 103.357L104 87v128l68-17.777z",
                        opacity: 0.1
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#535461",
                        d: "M36 103.357L104 87v128l-68-17.423z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#000",
                        d: "M36 101.412L104 85v129l-68-17.482z",
                        opacity: 0.17
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#535461",
                        d: "M104 87.67L139.532 58 207 75.394 171.468 104zM2 75.577L36.589 103 104 86.827 69.765 58z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#000",
                        d: "M2 75.747L37.486 104 105 87.67 69.869 58z",
                        opacity: 0.05
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        width: 50.484,
                        height: 45.833,
                        x: 0.235,
                        y: 0.067,
                        fill: "url(#prefix__e)",
                        opacity: 0.5,
                        rx: 4.5,
                        transform: "translate(54 72)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        width: 49,
                        height: 45,
                        x: 54,
                        y: 72,
                        fill: "#F5F5F5",
                        rx: 4.5
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        width: 8,
                        height: 7,
                        x: 58,
                        y: 80,
                        fill: "#005AEE",
                        rx: 3.5
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        width: 33,
                        height: 1,
                        x: 69,
                        y: 79,
                        fill: "#E0E0E0",
                        rx: 0.5
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        width: 33,
                        height: 1,
                        x: 69,
                        y: 82,
                        fill: "#E0E0E0",
                        rx: 0.5
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        width: 44,
                        height: 1,
                        x: 58,
                        y: 91,
                        fill: "#E0E0E0",
                        rx: 0.5
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        width: 44,
                        height: 1,
                        x: 58,
                        y: 93,
                        fill: "#E0E0E0",
                        rx: 0.5
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        width: 44,
                        height: 1,
                        x: 58,
                        y: 97,
                        fill: "#E0E0E0",
                        rx: 0.5
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        width: 26,
                        height: 1,
                        x: 57,
                        y: 99,
                        fill: "#E0E0E0",
                        rx: 0.5
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        width: 44,
                        height: 1,
                        x: 58,
                        y: 102,
                        fill: "#E0E0E0",
                        rx: 0.5
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        width: 44,
                        height: 1,
                        x: 58,
                        y: 105,
                        fill: "#E0E0E0",
                        rx: 0.5
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        width: 44,
                        height: 1,
                        x: 58,
                        y: 108,
                        fill: "#E0E0E0",
                        rx: 0.5
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        width: 26,
                        height: 1,
                        x: 57,
                        y: 111,
                        fill: "#E0E0E0",
                        rx: 0.5
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        width: 50.766,
                        height: 45.833,
                        x: 0.205,
                        y: 0.064,
                        fill: "url(#prefix__A)",
                        opacity: 0.5,
                        rx: 4.5,
                        transform: "translate(61 83)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        width: 49,
                        height: 45,
                        x: 62,
                        y: 83,
                        fill: "#FFF",
                        rx: 4.5
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        width: 8,
                        height: 7,
                        x: 66,
                        y: 90,
                        fill: "#005AEE",
                        rx: 3.5
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        width: 33,
                        height: 1,
                        x: 77,
                        y: 90,
                        fill: "#E0E0E0",
                        rx: 0.5
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        width: 33,
                        height: 1,
                        x: 77,
                        y: 92,
                        fill: "#E0E0E0",
                        rx: 0.5
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        width: 44,
                        height: 1,
                        x: 66,
                        y: 102,
                        fill: "#E0E0E0",
                        rx: 0.5
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        width: 44,
                        height: 1,
                        x: 66,
                        y: 104,
                        fill: "#E0E0E0",
                        rx: 0.5
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        width: 44,
                        height: 1,
                        x: 66,
                        y: 108,
                        fill: "#E0E0E0",
                        rx: 0.5
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        width: 26,
                        height: 1,
                        x: 65,
                        y: 110,
                        fill: "#E0E0E0",
                        rx: 0.5
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        width: 44,
                        height: 1,
                        x: 66,
                        y: 114,
                        fill: "#E0E0E0",
                        rx: 0.5
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        width: 44,
                        height: 1,
                        x: 66,
                        y: 116,
                        fill: "#E0E0E0",
                        rx: 0.5
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        width: 44,
                        height: 1,
                        x: 66,
                        y: 119,
                        fill: "#E0E0E0",
                        rx: 0.5
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        width: 26,
                        height: 1,
                        x: 65,
                        y: 121,
                        fill: "#E0E0E0",
                        rx: 0.5
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "url(#prefix__B)",
                        d: "M.097.146h43.827v51.826H.097z",
                        opacity: 0.5,
                        transform: "translate(91 88)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#FFF",
                        d: "M92 89h41v50H92z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "url(#prefix__C)",
                        fillRule: "nonzero",
                        d: "M7.683 1.34V.202H3.184V1.34H.037v5.582H10.83V1.34H7.683zM3.734.617H7.12v.723H3.734V.617z",
                        opacity: 0.5,
                        transform: "translate(107 96)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#005AEE",
                        d: "M108 97h10v6h-10z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#005AEE",
                        d: "M111 96v2h.499v-1.429h3V98H115v-2z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#E0E0E0",
                        d: "M98 111h29v1H98zm0 8h29v1H98zm0 2h29v1H98zm0-4h12v1H98z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#3AD29F",
                        d: "M118 117h9v1h-9z",
                        opacity: 0.6
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#005AEE",
                        d: "M109 126h9v1h-9z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#535461",
                        d: "M36 102v94.521L104.081 214l.919-93.809z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#535461",
                        d: "M172 196.166L104 214v-93.809L172 102z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#000",
                        d: "M172 196.166L104 214v-93.809L172 102z",
                        opacity: 0.07
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#000",
                        d: "M145 165.585V197l27-7.582V158z",
                        opacity: 0.07
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "url(#prefix__e)",
                        d: "M137 95h20v19h-20z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#F5F5F5",
                        d: "M136 96h20v18h-20z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "url(#prefix__D)",
                        fillRule: "nonzero",
                        d: "M5.541 1.089V.075H2.307v1.002H.043v4.914h7.762V1.089H5.541zM2.712.453h2.427v.636H2.712V.453z",
                        opacity: 0.5,
                        transform: "translate(143 98)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#005AEE",
                        d: "M143 99h7v4h-7zm2-1v1h.376v-.715h2.251V99H148v-1zm-1.755 8.336h6.653v1.332h-6.653z",
                        opacity: 0.6
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#BDBDBD",
                        d: "M140 108h12v1h-12z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "url(#prefix__e)",
                        d: "M117 0h20v19h-20z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#F5F5F5",
                        d: "M117 1h20v18h-20z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "url(#prefix__E)",
                        fillRule: "nonzero",
                        d: "M5.576 1.157V.206H2.341v.951H.077v4.68H7.84v-4.68H5.576zM2.746.551h2.427v.606H2.747V.551z",
                        opacity: 0.5,
                        transform: "translate(123 3)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#005AEE",
                        d: "M124 4h7v4h-7zm2-1v1h.376v-.715h2.251V4H129V3zm-1.989 9.065h6.919v1h-6.919z",
                        opacity: 0.6
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#BDBDBD",
                        d: "M121 13h12v1h-12z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "url(#prefix__F)",
                        d: "M.131.185h25.645v21.812H.131z",
                        opacity: 0.5,
                        transform: "translate(89 36)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#F2F2F2",
                        d: "M89 36h25v21H89z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#005AEE",
                        d: "M89 36h25v5H89z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#000",
                        d: "M89 36h25v5H89z",
                        opacity: 0.1
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#E0E0E0",
                        d: "M91 43h21v3H91zm0 5h15v1H91zm0 1h10v1H91zm0 2h13v1H91zm0 1h15v1H91zm0 2h5v1h-5z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "url(#prefix__e)",
                        d: "M.095.061h32.627v25.831H.095z",
                        opacity: 0.5,
                        transform: "translate(127 52)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#FFF",
                        d: "M128 53h31v25h-31z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#005AEE",
                        d: "M128 53h31v6h-31z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#F5F5F5",
                        d: "M130 60h26v3h-26z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#E0E0E0",
                        d: "M130 66h19v1h-19zm0 2h13v1h-13zm1 2h16v1h-16zm-1 2h19v1h-19zm1 2h6v1h-6z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#69F0AE",
                        d: "M132 61h7v1h-7z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#000",
                        d: "M35 151.442L73.253 161 104 136.217v-15.223L35.714 104zm138 0L134.747 161 104 136.217v-15.223L172.286 104z",
                        opacity: 0.1
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#535461",
                        d: "M36.589 103L2 131.883 69.411 149 104 121.187zm136.249 0L208 131.883 140.518 149 105 121.187z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#000",
                        d: "M172.838 103L208 131.883 140.518 149 105 121.187z",
                        opacity: 0.07
                    })
                ]
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/profile/ProductList.tsx














function ProductList(param) {
    var products = param.products, government = param.government, dataIntercomTarget = param.dataIntercomTarget;
    var intl = (0,useIntl/* default */.Z)();
    var ref = (0,react.useState)(""), filter = ref[0], setFilter = ref[1];
    var filtered = products.filter(function(product) {
        if (!product.name || !filter) {
            return true;
        }
        return product.name.toLowerCase().includes(filter.toLowerCase());
    });
    if (products.length === 0) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Toggle */.ZD, {
            initial: false,
            children: function(param) {
                var on = param.on, toggle = param.toggle;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(government_AddProductsToStack, {
                            government: government,
                            productsInStack: products,
                            isOpen: on,
                            toggleOpen: toggle
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NoProductsInStack, {
                            government: government,
                            onAddProduct: toggle
                        })
                    ]
                });
            }
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        "data-intercom-target": dataIntercomTarget,
        css: {
            background: "#fff",
            borderRadius: 5,
            border: "1px solid ".concat(palette/* lightestGray */.v2)
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: {
                padding: 16
            },
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(spacings/* Margin */.Zt, {
                    mb: 16,
                    css: {
                        display: "flex"
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Input */.II, {
                            placeholder: intl.formatMessage({
                                defaultMessage: "Search for products",
                                id: "gUIhhI"
                            }),
                            value: filter,
                            onChange: function(e) {
                                return setFilter(e.target.value);
                            }
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Toggle */.ZD, {
                            children: function(param) {
                                var isOpen = param.on, toggle = param.toggle;
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(government_AddProductsToStack, {
                                            government: government,
                                            productsInStack: products,
                                            isOpen: isOpen,
                                            toggleOpen: toggle
                                        }),
                                        government.viewerIsMember && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                                            theme: "link",
                                            color: palette/* innovatorBlue */.LD,
                                            textColor: palette/* innovatorBlue */.LD,
                                            onClick: toggle,
                                            css: {
                                                color: palette/* innovatorBlue */.LD,
                                                marginLeft: 16,
                                                textTransform: "uppercase"
                                            },
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                defaultMessage: "Edit",
                                                id: "wEQDC6"
                                            })
                                        })
                                    ]
                                });
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: (0,mediaQueries/* default */.Z)({
                        display: "grid",
                        gridTemplateColumns: [
                            "1fr",
                            "1fr 1fr 1fr"
                        ],
                        gridColumnGap: 32,
                        gridRowGap: 32
                    }),
                    children: [
                        filtered.length === 0 && filter.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NoResultsFound/* default */.Z, {}),
                        filtered.map(function(product) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                css: {
                                    display: "flex",
                                    overflow: "hidden"
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                        href: "/products/".concat(product.slug),
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(profile_picture/* default */.Z, {
                                                image: product.logo,
                                                name: product.name,
                                                size: "xsmall",
                                                css: {
                                                    borderRadius: 6,
                                                    "& > img": {
                                                        borderRadius: 6,
                                                        padding: 0
                                                    },
                                                    padding: 0
                                                }
                                            }, product._id)
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                        css: {
                                            marginLeft: 12,
                                            overflow: "hidden",
                                            textOverflow: "ellipsis"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                                href: "/products/".concat(product.slug),
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                                        css: {
                                                            overflow: "hidden",
                                                            whiteSpace: "nowrap",
                                                            textOverflow: "ellipsis",
                                                            margin: 0,
                                                            fontSize: 18,
                                                            fontWeight: "bold",
                                                            color: palette/* primary */.T$
                                                        },
                                                        children: product.name
                                                    })
                                                })
                                            }),
                                            product.company && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                                href: "/vendors/".concat(product.company.slug),
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                                    css: {
                                                        fontSize: 13,
                                                        color: palette/* sealBlue */.N9,
                                                        lineHeight: "17px"
                                                    },
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Dotdotdot/* default */.Z, {
                                                        clamp: 1,
                                                        children: [
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                                defaultMessage: "From",
                                                                id: "dM+p3/"
                                                            }),
                                                            " ",
                                                            product.company.name
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                                css: {
                                                    fontSize: 13,
                                                    color: palette/* sealBlue */.N9,
                                                    lineHeight: "17px"
                                                }
                                            })
                                        ]
                                    })
                                ]
                            }, product._id);
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./components/profile/ProfileNavbar.tsx
var ProfileNavbar = __webpack_require__(81558);
// EXTERNAL MODULE: ./components/profile/Resources.tsx
var Resources = __webpack_require__(57473);
// EXTERNAL MODULE: ./components/profile/ResourcesForm.tsx + 2 modules
var ResourcesForm = __webpack_require__(5676);
// EXTERNAL MODULE: ./components/profile/Team.tsx
var Team = __webpack_require__(13005);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.9_mnlteiidv5se4zpyvopwg4rohq/node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(49550);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+project@2.37.38_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/project/index.ts + 59 modules
var _govlaunch_project = __webpack_require__(78062);
;// CONCATENATED MODULE: ./lib/queries/ProjectsByGovernmentQuery.ts

function ProjectsByGovernmentQuery_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ProjectsByGovernment($slug: String!, $cursor: Cursor, $limit: Int = 6) {\n    projectsByGovernment(slug: $slug, cursor: $cursor, limit: $limit) {\n      items {\n        _id\n        ...ProjectCardFields\n      }\n      pageInfo {\n        hasNextPage\n        endCursor\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    ProjectsByGovernmentQuery_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ var ProjectsByGovernmentQuery = ((0,lib/* gql */.Ps)(ProjectsByGovernmentQuery_templateObject(), _govlaunch_project/* ProjectCardFieldsFragment */.SS));

// EXTERNAL MODULE: ./src/components/project/CreateProjectModal.tsx
var CreateProjectModal = __webpack_require__(23115);
// EXTERNAL MODULE: ./src/components/project/listing/computeNavigationProps.tsx
var computeNavigationProps = __webpack_require__(36668);
// EXTERNAL MODULE: ./components/profile/NoProjectsBox.tsx
var NoProjectsBox = __webpack_require__(88925);
// EXTERNAL MODULE: ./lib/hooks/useIsMobile.ts
var useIsMobile = __webpack_require__(67459);
// EXTERNAL MODULE: ./lib/withIntl.tsx + 9 modules
var withIntl = __webpack_require__(21505);
// EXTERNAL MODULE: ./src/components/translation/TranslationButton.tsx
var TranslationButton = __webpack_require__(98769);
// EXTERNAL MODULE: ./components/project/EmptyProjectSlot.tsx
var EmptyProjectSlot = __webpack_require__(33563);
;// CONCATENATED MODULE: ./components/project/OwnGovernmentProjects.tsx















function OwnGovernmentProjects(param) {
    var _loading = param.loading, loading = _loading === void 0 ? false : _loading, government = param.government, projectsByGovernment = param.projectsByGovernment, onShowMore = param.onShowMore, onAddProject = param.onAddProject;
    var intl = (0,useIntl/* default */.Z)();
    var router = (0,next_router.useRouter)();
    var isMobile = (0,useIsMobile/* default */.Z)();
    var locale = (0,withIntl/* useIntlLocale */.U)().locale;
    if (!projectsByGovernment.items) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: {
            display: "grid",
            gridRowGap: 28
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                "data-intercom-target": "Government Projects",
                css: (0,mediaQueries/* default */.Z)({
                    display: "grid",
                    gridTemplateColumns: [
                        "1fr",
                        "1fr 1fr"
                    ],
                    gridColumnGap: 16,
                    gridRowGap: 16
                }),
                children: [
                    government.viewerIsMember && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyProjectSlot/* default */.Z, {
                        onClick: onAddProject,
                        text: intl.formatMessage({
                            defaultMessage: "Add another project",
                            id: "B0aG5V"
                        })
                    }),
                    projectsByGovernment.items.map(function(project) {
                        var linkHref = isMobile ? "/projects/".concat(project.slug) : (0,nextLinkHref/* appendNextLinkHrefParams */.o)(router, {
                            projectSlug: project.slug
                        });
                        var translationLinkHref = isMobile ? "/projects/".concat(project.slug) : (0,nextLinkHref/* appendNextLinkHrefParams */.o)(router, {
                            projectSlug: project.slug,
                            lang: locale
                        });
                        var translationLinkWrap = function() {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TranslationButton/* default */.Z, {
                                paddingY: "4px",
                                onClick: function(event) {
                                    event.preventDefault();
                                    event.stopPropagation();
                                    router.push(translationLinkHref);
                                }
                            });
                        };
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                            href: linkHref,
                            as: isMobile ? "/projects/".concat(project.slug) : "/governments/".concat(government.slug, "/projects/").concat(project.slug),
                            passHref: true,
                            scroll: false,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_govlaunch_project/* ProjectCard */.t, {
                                css: !isMobile ? {
                                    maxWidth: "385px"
                                } : {},
                                project: project,
                                translationLinkWrap: locale !== "en-US" ? translationLinkWrap : undefined
                            })
                        }, project._id);
                    }),
                    loading && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* LoadingSpinner */.TK, {})
                ]
            }),
            projectsByGovernment.pageInfo && projectsByGovernment.pageInfo.hasNextPage && projectsByGovernment.pageInfo.endCursor && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                onClick: function() {
                    return onShowMore();
                },
                css: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    margin: 1,
                    padding: 10,
                    color: palette/* primary */.T$,
                    fontWeight: 500,
                    fontSize: 14,
                    lineHeight: 1.33,
                    letterSpacing: 1,
                    textTransform: "uppercase",
                    backgroundColor: "transparent",
                    border: "none",
                    outline: "none",
                    cursor: "pointer",
                    "&:active": {
                        opacity: 0.7
                    },
                    marginmt: 0
                },
                disabled: false,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                    id: "aWpBzj",
                    defaultMessage: "Show more"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/project/ProjectsFromOtherGovernments.tsx












function ProjectFromOtherGovernments(param) {
    var government = param.government, projectsByGovernment = param.projectsByGovernment;
    var router = (0,next_router.useRouter)();
    var isMobile = (0,useIsMobile/* default */.Z)();
    var locale = (0,withIntl/* useIntlLocale */.U)().locale;
    if (!projectsByGovernment.items) {
        return null;
    }
    var otherProjects = government.relatedProjects.slice(0, 6 - projectsByGovernment.items.length);
    if (!otherProjects || otherProjects.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: {
            display: "grid",
            gridRowGap: 24
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
                css: {
                    margin: 0,
                    color: palette/* sealBlue */.N9,
                    fontWeight: 400,
                    fontSize: 16
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                        defaultMessage: "Other projects in Govlaunch",
                        id: "5scVcr"
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: (0,mediaQueries/* default */.Z)({
                    display: "grid",
                    gridTemplateColumns: [
                        "1fr",
                        "1fr 1fr"
                    ],
                    gridColumnGap: 16,
                    gridRowGap: 16
                }),
                children: otherProjects.map(function(project) {
                    var linkHref = isMobile ? "/projects/".concat(project.slug) : (0,nextLinkHref/* appendNextLinkHrefParams */.o)(router, {
                        projectSlug: project.slug
                    });
                    var translationLinkHref = isMobile ? "/projects/".concat(project.slug, "/").concat(locale) : (0,nextLinkHref/* appendNextLinkHrefParams */.o)(router, {
                        projectSlug: project.slug,
                        lang: locale
                    });
                    var translationLinkWrap = function() {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TranslationButton/* default */.Z, {
                            paddingY: "4px",
                            onClick: function(event) {
                                event.preventDefault();
                                event.stopPropagation();
                                router.push(translationLinkHref);
                            }
                        });
                    };
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                        href: linkHref,
                        as: isMobile ? "/projects/".concat(project.slug) : "/governments/".concat(government.slug, "/projects/").concat(project.slug),
                        passHref: true,
                        scroll: false,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_govlaunch_project/* ProjectCard */.t, {
                            project: project,
                            translationLinkWrap: locale !== "en-US" ? translationLinkWrap : undefined
                        })
                    }, project._id);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./lib/queries/VerifiedGovernmentProjectsQuery.ts

function VerifiedGovernmentProjectsQuery_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query VerifiedGovernmentProjects($slug: String!, $limit: Int = 6, $cursor: Cursor) {\n    government(slug: $slug) {\n      _id\n      verifiedProjects(limit: $limit, cursor: $cursor) {\n        items {\n          ...ProjectCardFields\n        }\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    VerifiedGovernmentProjectsQuery_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ var VerifiedGovernmentProjectsQuery = ((0,lib/* gql */.Ps)(VerifiedGovernmentProjectsQuery_templateObject(), _govlaunch_project/* ProjectCardFieldsFragment */.SS));

;// CONCATENATED MODULE: ./components/project/VerifiedGovernmentProjects.tsx


















function VerifiedGovernmentProjects(param) {
    var governmentSlug = param.governmentSlug;
    var router = (0,next_router.useRouter)();
    var isMobile = (0,useIsMobile/* default */.Z)();
    var locale = (0,withIntl/* useIntlLocale */.U)().locale;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Query/* Query */.A, {
        query: VerifiedGovernmentProjectsQuery,
        variables: {
            slug: governmentSlug,
            cursor: null
        },
        children: function(param) {
            var data = param.data, fetchMore = param.fetchMore;
            if (!data || !data.government) {
                return null;
            }
            var verifiedProjects = data.government.verifiedProjects;
            if (!verifiedProjects.items || verifiedProjects.items.length === 0) {
                return null;
            }
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    display: "grid",
                    gridRowGap: 24
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
                                css: {
                                    margin: "0 0 16px 0",
                                    color: palette/* sealBlue */.N9,
                                    fontWeight: 400,
                                    fontSize: 16
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Verified Projects",
                                    id: "uxuBI+"
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                css: (0,mediaQueries/* default */.Z)({
                                    display: "grid",
                                    gridRowGap: 16,
                                    gridColumnGap: 16,
                                    gridTemplateColumns: [
                                        "1fr",
                                        "1fr 1fr"
                                    ]
                                }),
                                children: verifiedProjects.items.map(function(project) {
                                    var ref;
                                    var linkHref = isMobile ? "/projects/".concat(project.slug) : (0,nextLinkHref/* appendNextLinkHrefParams */.o)(router, {
                                        projectSlug: project.slug
                                    });
                                    var translationLinkHref = isMobile ? "/projects/".concat(project.slug, "/").concat(locale) : (0,nextLinkHref/* appendNextLinkHrefParams */.o)(router, {
                                        projectSlug: project.slug,
                                        lang: locale
                                    });
                                    var translationLinkWrap = function() {
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TranslationButton/* default */.Z, {
                                            paddingY: "4px",
                                            onClick: function(event) {
                                                event.preventDefault();
                                                event.stopPropagation();
                                                router.push(translationLinkHref);
                                            }
                                        });
                                    };
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                        href: linkHref,
                                        as: isMobile ? "/projects/".concat(project.slug) : "/governments/".concat(governmentSlug, "/projects/").concat(project.slug),
                                        passHref: true,
                                        scroll: false,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_govlaunch_project/* ProjectCard */.t, {
                                            project: project,
                                            firstLocationId: data === null || data === void 0 ? void 0 : (ref = data.government) === null || ref === void 0 ? void 0 : ref._id,
                                            translationLinkWrap: locale !== "en-US" ? translationLinkWrap : undefined
                                        })
                                    }, project._id);
                                })
                            })
                        ]
                    }),
                    verifiedProjects.pageInfo && verifiedProjects.pageInfo.hasNextPage && verifiedProjects.pageInfo.endCursor && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                        onClick: function() {
                            if (verifiedProjects.pageInfo && verifiedProjects.pageInfo.endCursor) {
                                fetchMore({
                                    variables: {
                                        slug: governmentSlug,
                                        cursor: verifiedProjects.pageInfo.endCursor
                                    },
                                    updateQuery: function(previousQueryResult, param) {
                                        var fetchMoreResult = param.fetchMoreResult;
                                        if (!previousQueryResult.government || !previousQueryResult.government.verifiedProjects.items || !fetchMoreResult || !fetchMoreResult.government || !fetchMoreResult.government.verifiedProjects || !fetchMoreResult.government.verifiedProjects.items) {
                                            return previousQueryResult;
                                        }
                                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, previousQueryResult), {
                                            groupBySlug: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, previousQueryResult.government), {
                                                verifiedProjects: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, fetchMoreResult.government.verifiedProjects), {
                                                    items: (0,_to_consumable_array/* default */.Z)(previousQueryResult.government.verifiedProjects.items).concat((0,_to_consumable_array/* default */.Z)(fetchMoreResult.government.verifiedProjects.items))
                                                })
                                            })
                                        });
                                    }
                                });
                            }
                        },
                        css: {
                            zIndex: 9999,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "100%",
                            margin: 1,
                            padding: 10,
                            color: palette/* primary */.T$,
                            fontWeight: 500,
                            fontSize: 14,
                            lineHeight: 1.33,
                            letterSpacing: 1,
                            textTransform: "uppercase",
                            backgroundColor: "transparent",
                            border: "none",
                            outline: "none",
                            cursor: "pointer",
                            "&:active": {
                                opacity: 0.7
                            },
                            marginmt: 0
                        },
                        disabled: false,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Show more",
                            id: "aWpBzj"
                        })
                    })
                ]
            });
        }
    });
};

;// CONCATENATED MODULE: ./components/project/FullGovernmentProjects.tsx
















function FullGovernmentProjects(param) {
    var government = param.government;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(false), createProjectModalOpen = ref[0], setCreateProjectModalOpen = ref[1];
    var ref1 = (0,useQuery/* useQuery */.a)(ProjectsByGovernmentQuery, {
        variables: {
            slug: government.slug,
            cursor: null,
            limit: 7
        },
        notifyOnNetworkStatusChange: true
    }), data = ref1.data, loading = ref1.loading, fetchMore = ref1.fetchMore, networkStatus = ref1.networkStatus;
    // https://github.com/apollographql/apollo-client/blob/master/packages/apollo-client/src/core/networkStatus.ts
    var isFirstLoad = loading && networkStatus === 1;
    var isLoadingMore = loading && networkStatus === 3;
    var projectSlug = (0,stringOrFirst/* default */.Z)(router.query.projectSlug);
    var governmentSlug = (0,stringOrFirst/* default */.Z)(router.query.governmentSlug);
    var lang = (0,stringOrFirst/* default */.Z)(router.query.lang);
    if (isFirstLoad) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FirstLoad, {});
    }
    if (!data || !data.projectsByGovernment) {
        return null;
    }
    var projectsByGovernment = data.projectsByGovernment;
    if (!projectsByGovernment.items) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            projectSlug && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProjectModal/* default */.Z, {
                projectSlug: projectSlug,
                navigation: (0,computeNavigationProps/* default */.Z)(projectsByGovernment.items.some(function(param) {
                    var slug = param.slug;
                    return slug === projectSlug;
                }) ? projectsByGovernment.items : government.relatedProjects, projectSlug),
                onClose: function() {
                    router.push("/governments/[governmentSlug]/[[...content]]", "/governments/".concat(government.slug, "/projects"));
                },
                lang: lang
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CreateProjectModal/* default */.Z, {
                isOpen: createProjectModalOpen,
                onClose: function() {
                    return setCreateProjectModalOpen(false);
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    display: "grid",
                    gridRowGap: 28
                },
                children: [
                    projectsByGovernment.items.length === 0 && government.viewerIsMember && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NoProjectsBox/* default */.Z, {
                        onAddProject: function() {
                            return setCreateProjectModalOpen(true);
                        },
                        dataIntercomTarget: "Government Projects",
                        addButtonIntercomTarget: "Government Add Project"
                    }),
                    projectsByGovernment.items.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OwnGovernmentProjects, {
                        loading: isLoadingMore,
                        government: government,
                        projectsByGovernment: projectsByGovernment,
                        onAddProject: function() {
                            return setCreateProjectModalOpen(true);
                        },
                        onShowMore: function() {
                            if (!projectsByGovernment.pageInfo || !projectsByGovernment.pageInfo.endCursor) {
                                return null;
                            }
                            fetchMore({
                                variables: {
                                    slug: government.slug,
                                    cursor: projectsByGovernment.pageInfo.endCursor,
                                    limit: 6
                                },
                                updateQuery: function(previousQueryResult, param) {
                                    var fetchMoreResult = param.fetchMoreResult;
                                    if (!fetchMoreResult || !fetchMoreResult.projectsByGovernment || !fetchMoreResult.projectsByGovernment.items || !previousQueryResult.projectsByGovernment || !previousQueryResult.projectsByGovernment.items) {
                                        return previousQueryResult;
                                    }
                                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, previousQueryResult), {
                                        projectsByGovernment: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, previousQueryResult.projectsByGovernment, fetchMoreResult.projectsByGovernment), {
                                            items: previousQueryResult.projectsByGovernment.items.concat(fetchMoreResult.projectsByGovernment.items)
                                        })
                                    });
                                }
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerifiedGovernmentProjects, {
                        governmentSlug: governmentSlug
                    }),
                    projectsByGovernment.items.length < 5 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProjectFromOtherGovernments, {
                        government: government,
                        projectsByGovernment: projectsByGovernment
                    })
                ]
            })
        ]
    });
};
function FirstLoad() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: {
            display: "grid",
            gridColumnGap: 16,
            gridTemplateColumns: "1fr 1fr",
            width: "100%"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* LoadingSpinner */.TK, {})
    });
}

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/head.js
var head = __webpack_require__(84217);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./components/seo/SeoHead.tsx
var SeoHead = __webpack_require__(35692);
;// CONCATENATED MODULE: ./components/seo/GovernmentPageSeo.tsx





function GovernmentPageSeo(param) {
    var government = param.government, tab = param.tab;
    if (!government.city) {
        return null;
    }
    var formatTab = tab;
    if (tab === "connect") {
        formatTab = "profile";
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SeoHead/* default */.Z, {
                title: getGovernmentFormattedTitle(formatTab, government),
                description: getGovernmentFormattedDescription(formatTab, government)
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                        name: "twitter:site",
                        content: "@Govlaunch"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                        name: "twitter:image",
                        content: government.logo || ""
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                        property: "og:image",
                        content: government.logo || ""
                    })
                ]
            })
        ]
    });
};
function getGovernmentFormattedTitle(tab, government) {
    var intl = (0,useIntl/* default */.Z)();
    if (!government || !government.city) {
        return intl.formatMessage({
            defaultMessage: "Search the wiki for local government innovation.",
            id: "Pa6P7h"
        });
    }
    var location = government.city.country === "US" ? government.city.state : government.city.country;
    switch(tab){
        case "projects":
            return intl.formatMessage({
                defaultMessage: "{government} – Govlaunch Projects",
                id: "WpWK2E"
            }, {
                government: "".concat(government.city.name, ", ").concat(location)
            });
        case "products":
            return intl.formatMessage({
                defaultMessage: "{government} – Govlaunch Products",
                id: "wraQhx"
            }, {
                government: "".concat(government.city.name, ", ").concat(location)
            });
        case "stories":
            return intl.formatMessage({
                defaultMessage: "{government} – Govlaunch Stories",
                id: "5EasiY"
            }, {
                government: "".concat(government.city.name, ", ").concat(location)
            });
        case "profile":
            return intl.formatMessage({
                defaultMessage: "{government} – Govlaunch Profile",
                id: "nmeTHz"
            }, {
                government: "".concat(government.city.name, ", ").concat(location)
            });
        case "actions":
            return intl.formatMessage({
                defaultMessage: "{government} – Govlaunch Actions",
                id: "YQypWv"
            }, {
                government: "".concat(government.city.name, ", ").concat(location)
            });
        case "settings":
            return intl.formatMessage({
                defaultMessage: "{government} – Govlaunch Settings",
                id: "F/o1NJ"
            }, {
                government: "".concat(government.city.name, ", ").concat(location)
            });
        case "sharing":
            return intl.formatMessage({
                defaultMessage: "{government} – Govlaunch Sharing",
                id: "k85rsY"
            }, {
                government: "".concat(government.city.name, ", ").concat(location)
            });
        default:
            return tab;
    }
}
function getGovernmentFormattedDescription(tab, government) {
    var intl = (0,useIntl/* default */.Z)();
    if (!government || !government.city) {
        return intl.formatMessage({
            defaultMessage: "Search the wiki for local government innovation.",
            id: "Pa6P7h"
        });
    }
    var location = government.city.country === "US" ? government.city.state : government.city.country;
    switch(tab){
        case "projects":
            return intl.formatMessage({
                defaultMessage: "Local government innovation projects from {government}. Search the wiki for local government innovation.",
                id: "5NIUrk"
            }, {
                government: "".concat(government.city.name, ", ").concat(location)
            });
        case "products":
            return intl.formatMessage({
                defaultMessage: "Local government technology products used by {government}. Search government technology products on Govlaunch.",
                id: "VuTieF"
            }, {
                government: "".concat(government.city.name, ", ").concat(location)
            });
        case "stories":
            return intl.formatMessage({
                defaultMessage: "Local government innovation stories from {government}. Search the wiki for local government innovation.",
                id: "8PCliH"
            }, {
                government: "".concat(government.city.name, ", ").concat(location)
            });
        case "profile":
            return intl.formatMessage({
                defaultMessage: "{government} local government profile. Search the wiki for local government innovation.",
                id: "I0EQDk"
            }, {
                government: "".concat(government.city.name, ", ").concat(location)
            });
        default:
            return "".concat(government.city.name, ", ").concat(location, " ").concat(tab);
    }
}

// EXTERNAL MODULE: ./components/vendor/profile/UpgradeAccountBanner.tsx + 1 modules
var UpgradeAccountBanner = __webpack_require__(4758);
;// CONCATENATED MODULE: ./lib/mutations/SetGovernmentResources.ts

function SetGovernmentResources_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation SetGovernmentResources($resources: [ResourceInput], $governmentId: ObjectId!) {\n    setGovernmentResources(resources: $resources, governmentId: $governmentId) {\n      _id\n      resources {\n        ... on LinkResource {\n          type\n          title\n          url\n        }\n        ... on TextResource {\n          type\n          title\n          body\n        }\n        ... on DownloadResource {\n          type\n          title\n          url\n          filename\n        }\n      }\n    }\n  }\n"
    ]);
    SetGovernmentResources_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var SetGovernmentResources = ((0,lib/* gql */.Ps)(SetGovernmentResources_templateObject()));

;// CONCATENATED MODULE: ./lib/queries/GovernmentQuery.ts

function GovernmentQuery_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query Government($governmentSlug: String!) {\n    government(slug: $governmentSlug) {\n      _id\n      slug\n      name\n      logo\n      site\n      enableSharing\n      cover {\n        original\n        repositioned\n      }\n      ownerless\n      isInnovator\n      viewerCanRequestAccess\n      viewerRequestedMembership\n      viewerRequestedOwnership\n      viewerCanInviteMembers\n      viewerCanRemoveMembers\n      viewerCanSeeTeam\n      viewerCanSeeProductStack\n      viewerIsMember\n      viewerIsOwner\n      isFollowing\n      budget\n      currency\n      membersCount\n      postsCount\n      feedCount\n      projectsCount\n      storiesCount\n      actionsCount\n      relatedGovernments {\n        _id\n        slug\n        logo\n        name\n        city {\n          _id\n          country\n          countryName\n        }\n      }\n      relatedProjects {\n        _id\n        ...ProjectCardFields\n      }\n      verifiedProjects {\n        items {\n          _id\n          ...ProjectCardFields\n        }\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n      }\n      sharing {\n        team\n        productStack\n        projects\n        stories\n        resources\n        awards\n      }\n      city {\n        _id\n        name\n        stateAbbreviation: state\n        state(full: true)\n        governmentType\n        population\n        country\n        countryName\n        county\n        zip\n      }\n      members {\n        _id\n        slug\n        firstName\n        fullName\n        jobTitle\n        avatar\n        isInnovator\n      }\n      stories {\n        items {\n          _id\n          title\n          slug\n          verticalCover\n          introduction\n          viewerCanRead\n          viewerIsAuthor\n          viewerDidBookmark\n          updatedAt\n          modifiedAt\n          createdAt\n          status\n          government {\n            _id\n            slug\n            name\n            logo\n            isInnovator\n            city {\n              _id\n              country\n              countryName\n            }\n          }\n        }\n      }\n      productTags {\n        _id\n        name\n      }\n\n      awards {\n        _id\n        name\n      }\n\n      productsCount\n      products {\n        _id\n        name\n        slug\n        description\n        logo\n        isDisruptor\n\n        inViewerStack\n        company {\n          _id\n          name\n          slug\n        }\n      }\n      resources {\n        ... on LinkResource {\n          type\n          title\n          url\n        }\n        ... on TextResource {\n          type\n          title\n          body\n        }\n        ... on DownloadResource {\n          type\n          title\n          url\n          filename\n        }\n      }\n      groups {\n        _id\n        name\n        slug\n\n        logo\n      }\n      settings {\n        projectSharingWithGroups {\n          _id\n          name\n          logo\n        }\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    GovernmentQuery_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ var GovernmentQuery = ((0,lib/* gql */.Ps)(GovernmentQuery_templateObject(), _govlaunch_project/* ProjectCardFieldsFragment */.SS));

// EXTERNAL MODULE: ./lib/route/Redirect.tsx
var Redirect = __webpack_require__(47116);
// EXTERNAL MODULE: ./lib/utils/mediaQueries.ts
var utils_mediaQueries = __webpack_require__(29713);
// EXTERNAL MODULE: ./lib/utils/safeGetQueryParameter.ts
var safeGetQueryParameter = __webpack_require__(35909);
// EXTERNAL MODULE: ./src/components/auth/SignInModal.tsx + 3 modules
var SignInModal = __webpack_require__(43316);
// EXTERNAL MODULE: ./src/components/navbar/NavbarLayout.tsx + 62 modules
var NavbarLayout = __webpack_require__(71858);
// EXTERNAL MODULE: ./types/types.ts
var types = __webpack_require__(43845);
;// CONCATENATED MODULE: ./pages/governments/[governmentSlug]/[[...content]].tsx





















// import Stack from "~/components/government/Stack";




















__webpack_require__.g.joinedFromToken = null;
var GovernmentPage = function(param) {
    var governmentSlug = param.governmentSlug, token = param.token, projectSlug = param.projectSlug, content = param.content;
    var user = (0,Auth/* useSelfie */.yD)();
    var router = (0,next_router.useRouter)();
    if (token && !user) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SignInModal/* SigninModal */.I, {
            isOpen: true,
            inviteToken: token,
            onRequestClose: function() {
                router.replace("/governments/".concat(governmentSlug));
                __webpack_require__.g.joinedFromToken = true;
            }
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavbarLayout/* default */.Z, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GovernmentProfile, {
            user: user,
            token: token,
            governmentSlug: governmentSlug,
            projectSlug: projectSlug,
            content: content
        })
    });
};
GovernmentPage.getInitialProps = function(param) {
    var query = param.query;
    return {
        governmentSlug: (0,safeGetQueryParameter/* default */.Z)(query, "governmentSlug"),
        token: (0,safeGetQueryParameter/* default */.Z)(query, "token"),
        projectSlug: (0,safeGetQueryParameter/* default */.Z)(query, "projectSlug"),
        content: (0,safeGetQueryParameter/* default */.Z)(query, "content")
    };
};
var GovernmentProfile = function(param) {
    var user = param.user, token = param.token, governmentSlug = param.governmentSlug, content = param.content;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Query/* Query */.A, {
        query: GovernmentQuery,
        variables: {
            governmentSlug: governmentSlug
        },
        children: function(param) {
            var loading = param.loading, data = param.data;
            if (loading) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    css: {
                        padding: 30,
                        width: "100%",
                        textAlign: "center"
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Loader */.aN, {
                        centered: true
                    })
                });
            }
            if (!data || !data.government) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Redirect/* default */.Z, {
                    to: "/"
                });
            }
            var government = data.government;
            if (token && user) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Redirect/* default */.Z, {
                    to: "/governments/".concat(governmentSlug)
                });
            }
            if (user && !user.verified) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GatedGovernmentProfile, {
                    government: government,
                    user: user
                });
            }
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    marginTop: 30,
                    marginBottom: 30,
                    width: "100%"
                },
                "data-intercom-target": government.membersCount > 0 ? null : "Claim Government",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Government, {
                    government: government,
                    user: user,
                    content: content
                })
            });
        }
    });
};
function GatedGovernmentProfile(param) {
    var government = param.government, user = param.user;
    var isMobile = (0,useIsMobile/* default */.Z)();
    if (!government || !user) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
        mt: 30,
        mb: 30,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: {
                maxWidth: 940,
                width: "100%",
                margin: "0 auto",
                padding: "0 15px",
                display: "grid",
                alignItems: "flex-start",
                gridGap: 16,
                gridAutoFlow: isMobile ? "row" : "column",
                gridTemplateColumns: isMobile ? "1fr" : "1fr 2fr"
            },
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GovernmentInfo, {
                    government: government,
                    user: user
                }),
                government.viewerCanRequestAccess && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RequestAccess, {
                    government: government
                })
            ]
        })
    });
}
function getTab(user, government, content) {
    if (content) {
        return content;
    }
    if (!user) {
        return "projects";
    }
    if (government.feedCount > 0) {
        return "connect";
    }
    return "projects";
}
var Government = function(param) {
    var government = param.government, user = param.user, content = param.content;
    var isMobile = (0,useIsMobile/* default */.Z)();
    if (!government) {
        return null;
    }
    var tab = getTab(user, government, content);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GovernmentPageSeo, {
                government: government,
                tab: tab
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(core/* Grid */.rj, {
                width: 1224,
                children: [
                    (government.cover && government.cover.original && user && user.canSeeActiveGovernments || government.viewerIsMember) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Row */.X2, {
                        mb: [
                            5,
                            5,
                            5,
                            5
                        ],
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(core/* Col */.JX, {
                            width: [
                                1,
                                1,
                                1,
                                1
                            ],
                            children: [
                                __webpack_require__.g.joinedFromToken && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                    mb: 12,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InviteMessage, {
                                        accepted: !!government.members.find(function(param) {
                                            var _id = param._id;
                                            return _id === (0,fp.get)("_id", user);
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    css: {
                                        position: "relative"
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SetProfileCover/* default */.Z, {
                                        entityType: "Government",
                                        targetId: government._id,
                                        children: function(param) {
                                            var onSetProfileCover = param.onSetProfileCover, onSetRepositionedCover = param.onSetRepositionedCover, onRemoveCover = param.onRemoveCover;
                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Cover/* default */.ZP, {
                                                alt: "Cover",
                                                height: 250,
                                                width: 1224,
                                                originalSource: (0,fp.getOr)(null, "cover.original", government),
                                                repositionedSource: (0,fp.getOr)(null, "cover.repositioned", government),
                                                placeholderSource: Cover/* PLACEHOLDER_COVER */.t2,
                                                onReposition: function(originalSource, cropState) {
                                                    var repositionedSource = (0,Cover/* makeImaginaryUrls */.oH)(originalSource, cropState);
                                                    onSetRepositionedCover(originalSource, repositionedSource.cropped, cropState);
                                                },
                                                onChange: onSetProfileCover,
                                                onRemove: onRemoveCover,
                                                readOnly: !government.viewerIsMember,
                                                containerProps: {
                                                    style: {
                                                        borderRadius: 5,
                                                        overflow: "hidden"
                                                    }
                                                }
                                            });
                                        }
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(core/* RowWrap */.xv, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Col */.JX, {
                                width: [
                                    1,
                                    1,
                                    4 / 12,
                                    4 / 12
                                ],
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                    css: {
                                        display: "grid",
                                        gridRowGap: 24
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GovernmentInfo, {
                                            government: government,
                                            user: user,
                                            content: content
                                        }),
                                        isMobile && user && user.canSeeActiveGovernments && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navbar, {
                                            government: government,
                                            tab: tab
                                        }),
                                        user && user.__typename === "GovernmentUser" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Team/* default */.Z, {
                                            members: government.members,
                                            viewerIsMember: government.viewerIsMember || false,
                                            viewerCanInviteMembers: government.viewerCanInviteMembers || false,
                                            viewerCanRemoveMembers: government.viewerCanRemoveMembers || false,
                                            viewerCanSeeTeam: government.viewerCanSeeTeam,
                                            targetType: "GOVERNMENT",
                                            targetId: government._id
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ResourcesForm/* ResourcesFormContextProvider */.Kf, {
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                                children: [
                                                    user && user.canSeeActiveGovernments && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ResourcesForm/* ResourcesFormContextConsumer */.tC, {
                                                        children: function(param) {
                                                            var toggle = param.toggle;
                                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GovernmentAwards, {
                                                                government: government,
                                                                onAddLink: toggle
                                                            });
                                                        }
                                                    }),
                                                    government.viewerIsMember && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
                                                        mutation: SetGovernmentResources,
                                                        children: function(setResources) {
                                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ResourcesForm/* default */.ZP, {
                                                                resources: government.resources,
                                                                dataIntercomTarget: government.viewerIsMember ? "Government Resources" : null,
                                                                onAdd: function(resource) {
                                                                    setResources({
                                                                        variables: {
                                                                            governmentId: government._id,
                                                                            resources: [
                                                                                resource
                                                                            ].concat((0,_to_consumable_array/* default */.Z)(government.resources)).map((0,fp.pick)([
                                                                                "type",
                                                                                "title",
                                                                                "url",
                                                                                "filename",
                                                                                "body",
                                                                                "addedAt"
                                                                            ]))
                                                                        }
                                                                    });
                                                                },
                                                                onRemove: function(resource) {
                                                                    return setResources({
                                                                        variables: {
                                                                            governmentId: government._id,
                                                                            resources: government.resources.filter(function(r) {
                                                                                return r !== resource;
                                                                            }).map((0,fp.pick)([
                                                                                "type",
                                                                                "title",
                                                                                "url",
                                                                                "filename",
                                                                                "body",
                                                                                "addedAt"
                                                                            ]))
                                                                        }
                                                                    });
                                                                }
                                                            });
                                                        }
                                                    })
                                                ]
                                            })
                                        }),
                                        !government.viewerIsMember && user && user.canSeeActiveGovernments && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Resources/* default */.Z, {
                                            resources: government.resources,
                                            dataIntercomTarget: government.viewerIsMember ? "Government Resources" : null
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ResourcesForm/* ResourcesFormContextProvider */.Kf, {
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                                children: [
                                                    user && user.canSeeActiveGovernments && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ResourcesForm/* ResourcesFormContextConsumer */.tC, {
                                                        children: function(param) {
                                                            var toggle = param.toggle;
                                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GovernmentAwards, {
                                                                government: government,
                                                                onAddLink: toggle
                                                            });
                                                        }
                                                    }),
                                                    government.viewerIsMember && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
                                                        mutation: SetGovernmentResources,
                                                        children: function(setResources) {
                                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ResourcesForm/* default */.ZP, {
                                                                resources: government.resources,
                                                                dataIntercomTarget: government.viewerIsMember ? "Government Resources" : null,
                                                                onAdd: function(resource) {
                                                                    setResources({
                                                                        variables: {
                                                                            governmentId: government._id,
                                                                            resources: [
                                                                                resource
                                                                            ].concat((0,_to_consumable_array/* default */.Z)(government.resources)).map((0,fp.pick)([
                                                                                "type",
                                                                                "title",
                                                                                "url",
                                                                                "filename",
                                                                                "body",
                                                                                "addedAt"
                                                                            ]))
                                                                        }
                                                                    });
                                                                },
                                                                onRemove: function(resource) {
                                                                    return setResources({
                                                                        variables: {
                                                                            governmentId: government._id,
                                                                            resources: government.resources.filter(function(r) {
                                                                                return r !== resource;
                                                                            }).map((0,fp.pick)([
                                                                                "type",
                                                                                "title",
                                                                                "url",
                                                                                "filename",
                                                                                "body",
                                                                                "addedAt"
                                                                            ]))
                                                                        }
                                                                    });
                                                                }
                                                            });
                                                        }
                                                    })
                                                ]
                                            })
                                        }),
                                        !government.viewerIsMember && user && user.canSeeActiveGovernments && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Resources/* default */.Z, {
                                            resources: government.resources,
                                            dataIntercomTarget: government.viewerIsMember ? "Government Resources" : null
                                        }),
                                        user && user.__typename === "PendingUser" && !user.verified && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RequestAccess, {
                                            government: government
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Col */.JX, {
                                width: [
                                    1,
                                    1,
                                    8 / 12,
                                    8 / 12
                                ],
                                mt: [
                                    24,
                                    24,
                                    0,
                                    0
                                ],
                                children: user && user.__typename === "VendorUser" && !user.canSeeActiveGovernments ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UpgradeAccountBanner/* default */.Z, {}) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GovernmentTabs, {
                                    government: government,
                                    user: user,
                                    tab: tab
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
function GovernmentTabs(param) {
    var government = param.government, tab = param.tab, user = param.user;
    var isMobile = (0,useIsMobile/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            !isMobile && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navbar, {
                government: government,
                tab: tab
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    marginTop: 24
                },
                children: [
                    tab === "projects" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FullGovernmentProjects, {
                        government: government
                    }),
                    tab === "stories" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GovernmentStories, {
                        government: government,
                        stories: government.stories.items
                    }),
                    tab === "connect" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: {
                            display: "grid",
                            gridRowGap: 16
                        },
                        children: [
                            user && user.__typename === "GovernmentUser" && user.government && user.government._id === government._id && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WriteContentBox/* default */.Z, {
                                user: user,
                                dataIntercomTarget: government.viewerIsMember ? "Government Write Content Box" : null
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Feed/* default */.Z, {
                                targetId: government._id,
                                targetType: types/* IConnectTargetType.Government */.QY.Government
                            })
                        ]
                    }),
                    tab === "products" && government.products && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProductList, {
                            products: government.products,
                            government: government,
                            dataIntercomTarget: government.viewerIsMember ? "Government Products" : null
                        })
                    }),
                    (tab === "settings" || tab === "sharing") && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: {
                            display: "grid",
                            gridRowGap: 28
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GovernmentProfileForm, {
                                government: government
                            }),
                            government.groups.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProjectSharingWithGroups, {
                                government: government
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(government_SharingBox, {
                                government: government
                            })
                        ]
                    }),
                    tab === "actions" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(government_GovernmentActions, {
                        governmentSlug: government.slug
                    })
                ]
            })
        ]
    });
}
var InviteMessage = function(param) {
    var accepted = param.accepted;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: {
            backgroundColor: accepted ? palette/* greenBlue */.TG : palette/* red */.Q6,
            padding: 12,
            borderRadius: 4
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
            css: {
                color: palette/* white */.ix,
                fontSize: 14,
                margin: 0
            },
            children: accepted ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: "You're now a member of this Government!"
            }) : "Could not join this Government because the invite link has expired or is invalid."
        })
    });
};
function Navbar(param) {
    var government = param.government, tab = param.tab;
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ProfileNavbar/* default */.Z, {
        children: [
            government.feedCount > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewLinkTab/* default */.Z, {
                href: "/governments/[governmentSlug]",
                as: "/governments/".concat(government.slug),
                title: intl.formatMessage({
                    defaultMessage: "Activity",
                    id: "ZmlNQ3"
                }),
                count: government.feedCount,
                active: tab === "connect",
                dataIntercomTarget: government.viewerIsMember ? "Government Activity Tab" : null
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewLinkTab/* default */.Z, {
                href: "/governments/[governmentSlug]/[[...content]]",
                as: "/governments/".concat(government.slug, "/projects"),
                title: intl.formatMessage({
                    defaultMessage: "Projects",
                    id: "UxTJRa"
                }),
                count: government.projectsCount,
                active: tab === "projects",
                dataIntercomTarget: government.viewerIsMember ? "Government Projects Tab" : null
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewLinkTab/* default */.Z, {
                href: "/governments/[governmentSlug]/[[...content]]",
                as: "/governments/".concat(government.slug, "/products"),
                title: intl.formatMessage({
                    defaultMessage: "Products",
                    id: "7NFfmz"
                }),
                count: government.viewerCanSeeProductStack ? government.productsCount : 0,
                active: tab === "products",
                dataIntercomTarget: government.viewerIsMember ? "Government Products Tab" : null
            }),
            !!government.storiesCount && government.storiesCount > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewLinkTab/* default */.Z, {
                href: "/governments/[governmentSlug]/[[...content]]",
                as: "/governments/".concat(government.slug, "/stories"),
                title: intl.formatMessage({
                    defaultMessage: "Stories",
                    id: "Ldxym4"
                }),
                count: government.storiesCount,
                active: tab === "stories",
                dataIntercomTarget: government.viewerIsMember ? "Government Stories Tab" : null
            }),
            government.viewerIsMember && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewLinkTab/* default */.Z, {
                href: "/governments/[governmentSlug]/[[...content]]",
                as: "/governments/".concat(government.slug, "/actions"),
                title: intl.formatMessage({
                    defaultMessage: "Actions",
                    id: "wL7VAE"
                }),
                count: government.actionsCount,
                active: tab === "actions",
                dataIntercomTarget: government.viewerIsMember ? "Government Actions Tab" : null
            }),
            government.viewerIsMember && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewLinkTab/* default */.Z, {
                href: "/governments/[governmentSlug]/[[...content]]",
                as: "/governments/".concat(government.slug, "/settings"),
                title: intl.formatMessage({
                    defaultMessage: "Settings",
                    id: "D3idYv"
                }),
                count: 0,
                active: tab === "settings",
                css: (0,utils_mediaQueries/* default */.Z)({
                    marginLeft: [
                        0,
                        0,
                        0,
                        "auto"
                    ],
                    borderLeft: [
                        0,
                        0,
                        0,
                        "1px solid ".concat(palette/* lightestGray */.v2)
                    ]
                }),
                dataIntercomTarget: government.viewerIsMember ? "Government Settings Tab" : null
            })
        ]
    });
}
/* harmony default export */ var _content_ = (GovernmentPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3481,5522,2727,4968,1386,3685,916,3604,9932,504,5017,4185,9158,890,1249,9254,3393,2719,5676,9774,2888,179], function() { return __webpack_exec__(53559); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);